var map = {
	"./brands/42-group.svg": [
		22216,
		22216
	],
	"./brands/500px.svg": [
		84788,
		84788
	],
	"./brands/accessible-icon.svg": [
		47581,
		47581
	],
	"./brands/accusoft.svg": [
		97831,
		97831
	],
	"./brands/adn.svg": [
		86176,
		86176
	],
	"./brands/adversal.svg": [
		35993,
		35993
	],
	"./brands/affiliatetheme.svg": [
		24,
		24
	],
	"./brands/airbnb.svg": [
		57532,
		57532
	],
	"./brands/algolia.svg": [
		17252,
		43421
	],
	"./brands/alipay.svg": [
		68617,
		68617
	],
	"./brands/amazon-pay.svg": [
		20560,
		20560
	],
	"./brands/amazon.svg": [
		20913,
		20913
	],
	"./brands/amilia.svg": [
		42399,
		42399
	],
	"./brands/android.svg": [
		1913,
		1913
	],
	"./brands/angellist.svg": [
		23898,
		23898
	],
	"./brands/angrycreative.svg": [
		60249,
		60249
	],
	"./brands/angular.svg": [
		37145,
		37145
	],
	"./brands/app-store-ios.svg": [
		28426,
		28426
	],
	"./brands/app-store.svg": [
		32940,
		32940
	],
	"./brands/apper.svg": [
		51427,
		51427
	],
	"./brands/apple-pay.svg": [
		96922,
		96922
	],
	"./brands/apple.svg": [
		52132,
		52132
	],
	"./brands/artstation.svg": [
		6547,
		6547
	],
	"./brands/asymmetrik.svg": [
		71285,
		71285
	],
	"./brands/atlassian.svg": [
		72645,
		72645
	],
	"./brands/audible.svg": [
		50042,
		50042
	],
	"./brands/autoprefixer.svg": [
		34061,
		34061
	],
	"./brands/avianex.svg": [
		58354,
		58354
	],
	"./brands/aviato.svg": [
		7973,
		7973
	],
	"./brands/aws.svg": [
		12556,
		12556
	],
	"./brands/bandcamp.svg": [
		19776,
		19776
	],
	"./brands/battle-net.svg": [
		34938,
		34938
	],
	"./brands/behance.svg": [
		80589,
		80589
	],
	"./brands/bilibili.svg": [
		2814,
		2814
	],
	"./brands/bimobject.svg": [
		61739,
		61739
	],
	"./brands/bitbucket.svg": [
		7477,
		7477
	],
	"./brands/bitcoin.svg": [
		91234,
		91234
	],
	"./brands/bity.svg": [
		52648,
		52648
	],
	"./brands/black-tie.svg": [
		6426,
		6426
	],
	"./brands/blackberry.svg": [
		68545,
		68545
	],
	"./brands/blogger-b.svg": [
		53078,
		53078
	],
	"./brands/blogger.svg": [
		63419,
		63419
	],
	"./brands/bluetooth-b.svg": [
		17746,
		17746
	],
	"./brands/bluetooth.svg": [
		79051,
		79051
	],
	"./brands/bootstrap.svg": [
		67956,
		67956
	],
	"./brands/bots.svg": [
		18633,
		18633
	],
	"./brands/btc.svg": [
		11333,
		11333
	],
	"./brands/buffer.svg": [
		46490,
		46490
	],
	"./brands/buromobelexperte.svg": [
		56626,
		56626
	],
	"./brands/buy-n-large.svg": [
		15929,
		15929
	],
	"./brands/buysellads.svg": [
		74059,
		74059
	],
	"./brands/canadian-maple-leaf.svg": [
		38827,
		38827
	],
	"./brands/cc-amazon-pay.svg": [
		1749,
		1749
	],
	"./brands/cc-amex.svg": [
		93229,
		93229
	],
	"./brands/cc-apple-pay.svg": [
		10397,
		10397
	],
	"./brands/cc-diners-club.svg": [
		72486,
		72486
	],
	"./brands/cc-discover.svg": [
		50903,
		50903
	],
	"./brands/cc-jcb.svg": [
		58709,
		58709
	],
	"./brands/cc-mastercard.svg": [
		25423,
		25423
	],
	"./brands/cc-paypal.svg": [
		35906,
		35906
	],
	"./brands/cc-stripe.svg": [
		28232,
		28232
	],
	"./brands/cc-visa.svg": [
		60509,
		60509
	],
	"./brands/centercode.svg": [
		68078,
		68078
	],
	"./brands/centos.svg": [
		7021,
		7021
	],
	"./brands/chrome.svg": [
		21341,
		21341
	],
	"./brands/chromecast.svg": [
		6561,
		6561
	],
	"./brands/cloudflare.svg": [
		69801,
		69801
	],
	"./brands/cloudscale.svg": [
		68114,
		68114
	],
	"./brands/cloudsmith.svg": [
		96424,
		96424
	],
	"./brands/cloudversify.svg": [
		93337,
		93337
	],
	"./brands/cmplid.svg": [
		20126,
		20126
	],
	"./brands/codepen.svg": [
		96650,
		96650
	],
	"./brands/codiepie.svg": [
		7993,
		7993
	],
	"./brands/confluence.svg": [
		64929,
		64929
	],
	"./brands/connectdevelop.svg": [
		83535,
		83535
	],
	"./brands/contao.svg": [
		57465,
		57465
	],
	"./brands/cotton-bureau.svg": [
		20008,
		20008
	],
	"./brands/cpanel.svg": [
		58075,
		58075
	],
	"./brands/creative-commons-by.svg": [
		88820,
		88820
	],
	"./brands/creative-commons-nc-eu.svg": [
		77374,
		77374
	],
	"./brands/creative-commons-nc-jp.svg": [
		78523,
		78523
	],
	"./brands/creative-commons-nc.svg": [
		48496,
		48496
	],
	"./brands/creative-commons-nd.svg": [
		39526,
		39526
	],
	"./brands/creative-commons-pd-alt.svg": [
		43410,
		43410
	],
	"./brands/creative-commons-pd.svg": [
		94799,
		94799
	],
	"./brands/creative-commons-remix.svg": [
		86530,
		86530
	],
	"./brands/creative-commons-sa.svg": [
		87641,
		87641
	],
	"./brands/creative-commons-sampling-plus.svg": [
		5203,
		5203
	],
	"./brands/creative-commons-sampling.svg": [
		3502,
		3502
	],
	"./brands/creative-commons-share.svg": [
		18171,
		18171
	],
	"./brands/creative-commons-zero.svg": [
		70854,
		70854
	],
	"./brands/creative-commons.svg": [
		99705,
		99705
	],
	"./brands/critical-role.svg": [
		53167,
		53167
	],
	"./brands/css3-alt.svg": [
		66002,
		66002
	],
	"./brands/css3.svg": [
		15521,
		15521
	],
	"./brands/cuttlefish.svg": [
		95687,
		95687
	],
	"./brands/d-and-d-beyond.svg": [
		51317,
		51317
	],
	"./brands/d-and-d.svg": [
		67410,
		67410
	],
	"./brands/dailymotion.svg": [
		76663,
		76663
	],
	"./brands/dashcube.svg": [
		35683,
		35683
	],
	"./brands/deezer.svg": [
		98924,
		98924
	],
	"./brands/delicious.svg": [
		10677,
		10677
	],
	"./brands/deploydog.svg": [
		1302,
		1302
	],
	"./brands/deskpro.svg": [
		82375,
		82375
	],
	"./brands/dev.svg": [
		56878,
		56878
	],
	"./brands/deviantart.svg": [
		85635,
		85635
	],
	"./brands/dhl.svg": [
		89552,
		89552
	],
	"./brands/diaspora.svg": [
		94322,
		94322
	],
	"./brands/digg.svg": [
		57017,
		57017
	],
	"./brands/digital-ocean.svg": [
		8828,
		8828
	],
	"./brands/discord.svg": [
		329,
		329
	],
	"./brands/discourse.svg": [
		18537,
		18537
	],
	"./brands/dochub.svg": [
		27748,
		27748
	],
	"./brands/docker.svg": [
		95256,
		95256
	],
	"./brands/draft2digital.svg": [
		8947,
		8947
	],
	"./brands/dribbble.svg": [
		11249,
		11249
	],
	"./brands/dropbox.svg": [
		48346,
		48346
	],
	"./brands/drupal.svg": [
		78605,
		11700
	],
	"./brands/dyalog.svg": [
		82752,
		82752
	],
	"./brands/earlybirds.svg": [
		9469,
		9469
	],
	"./brands/ebay.svg": [
		68206,
		68206
	],
	"./brands/edge-legacy.svg": [
		261,
		261
	],
	"./brands/edge.svg": [
		87598,
		87598
	],
	"./brands/elementor.svg": [
		994,
		994
	],
	"./brands/ello.svg": [
		71841,
		71841
	],
	"./brands/ember.svg": [
		24731,
		24731
	],
	"./brands/empire.svg": [
		51993,
		51993
	],
	"./brands/envira.svg": [
		33632,
		33632
	],
	"./brands/erlang.svg": [
		30279,
		30279
	],
	"./brands/ethereum.svg": [
		93813,
		93813
	],
	"./brands/etsy.svg": [
		48139,
		48139
	],
	"./brands/evernote.svg": [
		50369,
		50369
	],
	"./brands/expeditedssl.svg": [
		67937,
		67937
	],
	"./brands/facebook-f.svg": [
		89691,
		89691
	],
	"./brands/facebook-messenger.svg": [
		98366,
		98366
	],
	"./brands/facebook.svg": [
		25825,
		25825
	],
	"./brands/fantasy-flight-games.svg": [
		64447,
		64447
	],
	"./brands/fedex.svg": [
		22053,
		22053
	],
	"./brands/fedora.svg": [
		74030,
		74030
	],
	"./brands/figma.svg": [
		67282,
		67282
	],
	"./brands/firefox-browser.svg": [
		25280,
		25280
	],
	"./brands/firefox.svg": [
		52193,
		52193
	],
	"./brands/first-order-alt.svg": [
		76464,
		76464
	],
	"./brands/first-order.svg": [
		47570,
		47570
	],
	"./brands/firstdraft.svg": [
		61601,
		61601
	],
	"./brands/flickr.svg": [
		90847,
		90847
	],
	"./brands/flipboard.svg": [
		42265,
		42265
	],
	"./brands/fly.svg": [
		22459,
		22459
	],
	"./brands/font-awesome.svg": [
		35840,
		35840
	],
	"./brands/fonticons-fi.svg": [
		16158,
		16158
	],
	"./brands/fonticons.svg": [
		812,
		812
	],
	"./brands/fort-awesome-alt.svg": [
		70247,
		70247
	],
	"./brands/fort-awesome.svg": [
		33136,
		77990
	],
	"./brands/forumbee.svg": [
		72442,
		72442
	],
	"./brands/foursquare.svg": [
		21795,
		21795
	],
	"./brands/free-code-camp.svg": [
		88969,
		88969
	],
	"./brands/freebsd.svg": [
		2246,
		2246
	],
	"./brands/fulcrum.svg": [
		46498,
		46498
	],
	"./brands/galactic-republic.svg": [
		38168,
		38168
	],
	"./brands/galactic-senate.svg": [
		91778,
		91778
	],
	"./brands/get-pocket.svg": [
		96750,
		96750
	],
	"./brands/gg-circle.svg": [
		12127,
		12127
	],
	"./brands/gg.svg": [
		84103,
		84103
	],
	"./brands/git-alt.svg": [
		39680,
		39680
	],
	"./brands/git.svg": [
		6580,
		6580
	],
	"./brands/github-alt.svg": [
		4486,
		4486
	],
	"./brands/github.svg": [
		42892,
		42892
	],
	"./brands/gitkraken.svg": [
		18800,
		18800
	],
	"./brands/gitlab.svg": [
		15718,
		15718
	],
	"./brands/gitter.svg": [
		89701,
		89701
	],
	"./brands/glide-g.svg": [
		6592,
		6592
	],
	"./brands/glide.svg": [
		17835,
		17835
	],
	"./brands/gofore.svg": [
		11794,
		11794
	],
	"./brands/golang.svg": [
		66027,
		66027
	],
	"./brands/goodreads-g.svg": [
		85612,
		85612
	],
	"./brands/goodreads.svg": [
		77494,
		77494
	],
	"./brands/google-drive.svg": [
		37890,
		37890
	],
	"./brands/google-pay.svg": [
		18358,
		18358
	],
	"./brands/google-play.svg": [
		52419,
		52419
	],
	"./brands/google-plus-g.svg": [
		85822,
		85822
	],
	"./brands/google-plus.svg": [
		77574,
		77574
	],
	"./brands/google-wallet.svg": [
		33369,
		33369
	],
	"./brands/google.svg": [
		12428,
		12428
	],
	"./brands/gratipay.svg": [
		55049,
		55049
	],
	"./brands/grav.svg": [
		88639,
		88639
	],
	"./brands/gripfire.svg": [
		37801,
		37801
	],
	"./brands/grunt.svg": [
		12644,
		12644
	],
	"./brands/guilded.svg": [
		81470,
		81470
	],
	"./brands/gulp.svg": [
		6723,
		6723
	],
	"./brands/hacker-news.svg": [
		51945,
		51945
	],
	"./brands/hackerrank.svg": [
		20545,
		20545
	],
	"./brands/hashnode.svg": [
		46083,
		46083
	],
	"./brands/hips.svg": [
		79331,
		79331
	],
	"./brands/hire-a-helper.svg": [
		82984,
		82984
	],
	"./brands/hive.svg": [
		24353,
		24353
	],
	"./brands/hooli.svg": [
		30986,
		30986
	],
	"./brands/hornbill.svg": [
		46978,
		46978
	],
	"./brands/hotjar.svg": [
		77847,
		77847
	],
	"./brands/houzz.svg": [
		64617,
		64617
	],
	"./brands/html5.svg": [
		14459,
		14459
	],
	"./brands/hubspot.svg": [
		48132,
		48132
	],
	"./brands/ideal.svg": [
		19971,
		19971
	],
	"./brands/imdb.svg": [
		75422,
		75422
	],
	"./brands/instagram.svg": [
		85895,
		85895
	],
	"./brands/instalod.svg": [
		47876,
		47876
	],
	"./brands/intercom.svg": [
		97930,
		97930
	],
	"./brands/internet-explorer.svg": [
		42532,
		42532
	],
	"./brands/invision.svg": [
		13814,
		13814
	],
	"./brands/ioxhost.svg": [
		13127,
		13127
	],
	"./brands/itch-io.svg": [
		91090,
		91090
	],
	"./brands/itunes-note.svg": [
		63754,
		63754
	],
	"./brands/itunes.svg": [
		59203,
		59203
	],
	"./brands/java.svg": [
		68200,
		68200
	],
	"./brands/jedi-order.svg": [
		88062,
		88062
	],
	"./brands/jenkins.svg": [
		65590,
		65590
	],
	"./brands/jira.svg": [
		43474,
		43474
	],
	"./brands/joget.svg": [
		36744,
		36744
	],
	"./brands/joomla.svg": [
		12274,
		12274
	],
	"./brands/js.svg": [
		95459,
		95459
	],
	"./brands/jsfiddle.svg": [
		71812,
		71812
	],
	"./brands/kaggle.svg": [
		36173,
		36173
	],
	"./brands/keybase.svg": [
		83424,
		83424
	],
	"./brands/keycdn.svg": [
		34483,
		34483
	],
	"./brands/kickstarter-k.svg": [
		32598,
		32598
	],
	"./brands/kickstarter.svg": [
		84781,
		84781
	],
	"./brands/korvue.svg": [
		43816,
		43816
	],
	"./brands/laravel.svg": [
		86134,
		86134
	],
	"./brands/lastfm.svg": [
		40658,
		18446
	],
	"./brands/leanpub.svg": [
		79332,
		79332
	],
	"./brands/less.svg": [
		33650,
		33650
	],
	"./brands/line.svg": [
		27606,
		27606
	],
	"./brands/linkedin-in.svg": [
		6833,
		6833
	],
	"./brands/linkedin.svg": [
		77203,
		77203
	],
	"./brands/linode.svg": [
		46796,
		46796
	],
	"./brands/linux.svg": [
		88396,
		88396
	],
	"./brands/lyft.svg": [
		45482,
		45482
	],
	"./brands/magento.svg": [
		83662,
		83662
	],
	"./brands/mailchimp.svg": [
		72653,
		72653
	],
	"./brands/mandalorian.svg": [
		90506,
		90506
	],
	"./brands/markdown.svg": [
		56224,
		56224
	],
	"./brands/mastodon.svg": [
		94826,
		94826
	],
	"./brands/maxcdn.svg": [
		79468,
		79468
	],
	"./brands/mdb.svg": [
		75104,
		75104
	],
	"./brands/medapps.svg": [
		57758,
		57758
	],
	"./brands/medium.svg": [
		88296,
		88296
	],
	"./brands/medrt.svg": [
		63511,
		63511
	],
	"./brands/meetup.svg": [
		32355,
		32355
	],
	"./brands/megaport.svg": [
		17036,
		17036
	],
	"./brands/mendeley.svg": [
		77661,
		77661
	],
	"./brands/meta.svg": [
		16639,
		16639
	],
	"./brands/microblog.svg": [
		51977,
		51977
	],
	"./brands/microsoft.svg": [
		45485,
		45485
	],
	"./brands/mix.svg": [
		89478,
		89478
	],
	"./brands/mixcloud.svg": [
		86709,
		86709
	],
	"./brands/mixer.svg": [
		7397,
		7397
	],
	"./brands/mizuni.svg": [
		16079,
		16079
	],
	"./brands/modx.svg": [
		77208,
		77208
	],
	"./brands/monero.svg": [
		77751,
		77751
	],
	"./brands/napster.svg": [
		6075,
		6075
	],
	"./brands/neos.svg": [
		89928,
		89928
	],
	"./brands/nfc-directional.svg": [
		61640,
		61640
	],
	"./brands/nfc-symbol.svg": [
		71038,
		71038
	],
	"./brands/nimblr.svg": [
		9729,
		9729
	],
	"./brands/node-js.svg": [
		40681,
		40681
	],
	"./brands/node.svg": [
		29838,
		38094
	],
	"./brands/npm.svg": [
		26704,
		26704
	],
	"./brands/ns8.svg": [
		35165,
		35165
	],
	"./brands/nutritionix.svg": [
		83824,
		98805
	],
	"./brands/octopus-deploy.svg": [
		56917,
		56917
	],
	"./brands/odnoklassniki.svg": [
		18445,
		18445
	],
	"./brands/odysee.svg": [
		46082,
		46082
	],
	"./brands/old-republic.svg": [
		15738,
		15738
	],
	"./brands/opencart.svg": [
		90960,
		90960
	],
	"./brands/openid.svg": [
		40764,
		40764
	],
	"./brands/opera.svg": [
		8793,
		8793
	],
	"./brands/optin-monster.svg": [
		89575,
		89575
	],
	"./brands/orcid.svg": [
		2597,
		9454
	],
	"./brands/osi.svg": [
		41962,
		41962
	],
	"./brands/padlet.svg": [
		92429,
		92429
	],
	"./brands/page4.svg": [
		50049,
		50049
	],
	"./brands/pagelines.svg": [
		99560,
		99560
	],
	"./brands/palfed.svg": [
		10875,
		10875
	],
	"./brands/patreon.svg": [
		72329,
		72329
	],
	"./brands/paypal.svg": [
		22274,
		22274
	],
	"./brands/perbyte.svg": [
		65679,
		65679
	],
	"./brands/periscope.svg": [
		35026,
		35026
	],
	"./brands/phabricator.svg": [
		60922,
		60922
	],
	"./brands/phoenix-framework.svg": [
		88525,
		88525
	],
	"./brands/phoenix-squadron.svg": [
		37014,
		37014
	],
	"./brands/php.svg": [
		1000,
		1000
	],
	"./brands/pied-piper-alt.svg": [
		50656,
		50656
	],
	"./brands/pied-piper-hat.svg": [
		66650,
		66650
	],
	"./brands/pied-piper-pp.svg": [
		56404,
		56404
	],
	"./brands/pied-piper.svg": [
		32121,
		32121
	],
	"./brands/pinterest-p.svg": [
		57919,
		57919
	],
	"./brands/pinterest.svg": [
		70876,
		70876
	],
	"./brands/pix.svg": [
		48682,
		48682
	],
	"./brands/playstation.svg": [
		51658,
		51658
	],
	"./brands/product-hunt.svg": [
		13061,
		13061
	],
	"./brands/pushed.svg": [
		32925,
		32925
	],
	"./brands/python.svg": [
		27983,
		27983
	],
	"./brands/qq.svg": [
		90910,
		90910
	],
	"./brands/quinscape.svg": [
		70940,
		70940
	],
	"./brands/quora.svg": [
		82205,
		82205
	],
	"./brands/r-project.svg": [
		89687,
		89687
	],
	"./brands/raspberry-pi.svg": [
		75518,
		75518
	],
	"./brands/ravelry.svg": [
		16730,
		16730
	],
	"./brands/react.svg": [
		38106,
		38106
	],
	"./brands/reacteurope.svg": [
		37780,
		37780
	],
	"./brands/readme.svg": [
		93638,
		93638
	],
	"./brands/rebel.svg": [
		72870,
		72870
	],
	"./brands/red-river.svg": [
		20431,
		20431
	],
	"./brands/reddit-alien.svg": [
		92413,
		92413
	],
	"./brands/reddit.svg": [
		92503,
		92503
	],
	"./brands/redhat.svg": [
		85605,
		85605
	],
	"./brands/renren.svg": [
		19529,
		19529
	],
	"./brands/replyd.svg": [
		69629,
		69629
	],
	"./brands/researchgate.svg": [
		64096,
		64096
	],
	"./brands/resolving.svg": [
		48471,
		48471
	],
	"./brands/rev.svg": [
		28169,
		28169
	],
	"./brands/rocketchat.svg": [
		86302,
		86302
	],
	"./brands/rockrms.svg": [
		55526,
		55526
	],
	"./brands/rust.svg": [
		73699,
		73699
	],
	"./brands/safari.svg": [
		50202,
		50202
	],
	"./brands/salesforce.svg": [
		69691,
		69691
	],
	"./brands/sass.svg": [
		60229,
		60229
	],
	"./brands/schlix.svg": [
		8801,
		8801
	],
	"./brands/screenpal.svg": [
		99637,
		99637
	],
	"./brands/scribd.svg": [
		70888,
		70888
	],
	"./brands/searchengin.svg": [
		1191,
		1191
	],
	"./brands/sellcast.svg": [
		81962,
		81962
	],
	"./brands/sellsy.svg": [
		94530,
		94530
	],
	"./brands/servicestack.svg": [
		19055,
		19055
	],
	"./brands/shirtsinbulk.svg": [
		17613,
		17613
	],
	"./brands/shopify.svg": [
		48743,
		87995
	],
	"./brands/shopware.svg": [
		43332,
		43332
	],
	"./brands/simplybuilt.svg": [
		17063,
		17063
	],
	"./brands/sistrix.svg": [
		92502,
		41868
	],
	"./brands/sith.svg": [
		55904,
		55904
	],
	"./brands/sitrox.svg": [
		92011,
		92011
	],
	"./brands/sketch.svg": [
		27499,
		27499
	],
	"./brands/skyatlas.svg": [
		44492,
		44492
	],
	"./brands/skype.svg": [
		90052,
		90052
	],
	"./brands/slack.svg": [
		12582,
		12582
	],
	"./brands/slideshare.svg": [
		3330,
		3330
	],
	"./brands/snapchat.svg": [
		61382,
		61382
	],
	"./brands/soundcloud.svg": [
		61124,
		61124
	],
	"./brands/sourcetree.svg": [
		22256,
		22256
	],
	"./brands/space-awesome.svg": [
		65970,
		65970
	],
	"./brands/speakap.svg": [
		29735,
		29735
	],
	"./brands/speaker-deck.svg": [
		84005,
		84005
	],
	"./brands/spotify.svg": [
		53614,
		53614
	],
	"./brands/square-behance.svg": [
		75756,
		75756
	],
	"./brands/square-dribbble.svg": [
		25775,
		25775
	],
	"./brands/square-facebook.svg": [
		49070,
		49070
	],
	"./brands/square-font-awesome-stroke.svg": [
		73595,
		73595
	],
	"./brands/square-font-awesome.svg": [
		80225,
		80225
	],
	"./brands/square-git.svg": [
		75523,
		75523
	],
	"./brands/square-github.svg": [
		88638,
		88638
	],
	"./brands/square-gitlab.svg": [
		25277,
		25277
	],
	"./brands/square-google-plus.svg": [
		86503,
		86503
	],
	"./brands/square-hacker-news.svg": [
		91648,
		91648
	],
	"./brands/square-instagram.svg": [
		66870,
		66870
	],
	"./brands/square-js.svg": [
		30075,
		30075
	],
	"./brands/square-lastfm.svg": [
		85401,
		85401
	],
	"./brands/square-odnoklassniki.svg": [
		36164,
		36164
	],
	"./brands/square-pied-piper.svg": [
		33486,
		33486
	],
	"./brands/square-pinterest.svg": [
		15488,
		15488
	],
	"./brands/square-reddit.svg": [
		70922,
		70922
	],
	"./brands/square-snapchat.svg": [
		90486,
		90486
	],
	"./brands/square-steam.svg": [
		63382,
		63382
	],
	"./brands/square-tumblr.svg": [
		41455,
		41455
	],
	"./brands/square-twitter.svg": [
		42093,
		42093
	],
	"./brands/square-viadeo.svg": [
		27205,
		27205
	],
	"./brands/square-vimeo.svg": [
		11030,
		11030
	],
	"./brands/square-whatsapp.svg": [
		10122,
		10122
	],
	"./brands/square-xing.svg": [
		83221,
		83221
	],
	"./brands/square-youtube.svg": [
		83501,
		83501
	],
	"./brands/squarespace.svg": [
		53226,
		53226
	],
	"./brands/stack-exchange.svg": [
		32352,
		32352
	],
	"./brands/stack-overflow.svg": [
		30839,
		30839
	],
	"./brands/stackpath.svg": [
		82300,
		82300
	],
	"./brands/staylinked.svg": [
		19908,
		19908
	],
	"./brands/steam-symbol.svg": [
		52855,
		52855
	],
	"./brands/steam.svg": [
		95865,
		95865
	],
	"./brands/sticker-mule.svg": [
		51215,
		51215
	],
	"./brands/strava.svg": [
		76650,
		76650
	],
	"./brands/stripe-s.svg": [
		45917,
		45917
	],
	"./brands/stripe.svg": [
		74755,
		74755
	],
	"./brands/stubber.svg": [
		28847,
		28847
	],
	"./brands/studiovinari.svg": [
		35475,
		35475
	],
	"./brands/stumbleupon-circle.svg": [
		47511,
		47511
	],
	"./brands/stumbleupon.svg": [
		2573,
		2573
	],
	"./brands/superpowers.svg": [
		93443,
		93443
	],
	"./brands/supple.svg": [
		72554,
		72554
	],
	"./brands/suse.svg": [
		66652,
		66652
	],
	"./brands/swift.svg": [
		20907,
		20907
	],
	"./brands/symfony.svg": [
		15128,
		15128
	],
	"./brands/teamspeak.svg": [
		96416,
		96416
	],
	"./brands/telegram.svg": [
		43086,
		43086
	],
	"./brands/tencent-weibo.svg": [
		94155,
		94155
	],
	"./brands/the-red-yeti.svg": [
		52356,
		52356
	],
	"./brands/themeco.svg": [
		19736,
		19736
	],
	"./brands/themeisle.svg": [
		84059,
		84059
	],
	"./brands/think-peaks.svg": [
		1149,
		1149
	],
	"./brands/tiktok.svg": [
		30669,
		30669
	],
	"./brands/trade-federation.svg": [
		59484,
		59484
	],
	"./brands/trello.svg": [
		84527,
		84527
	],
	"./brands/tumblr.svg": [
		90965,
		90965
	],
	"./brands/twitch.svg": [
		33207,
		33207
	],
	"./brands/twitter.svg": [
		22463,
		22463
	],
	"./brands/typo3.svg": [
		11077,
		11077
	],
	"./brands/uber.svg": [
		90480,
		90480
	],
	"./brands/ubuntu.svg": [
		96414,
		96414
	],
	"./brands/uikit.svg": [
		92926,
		92926
	],
	"./brands/umbraco.svg": [
		44469,
		44469
	],
	"./brands/uncharted.svg": [
		67029,
		67029
	],
	"./brands/uniregistry.svg": [
		56842,
		56842
	],
	"./brands/unity.svg": [
		50883,
		50883
	],
	"./brands/unsplash.svg": [
		32432,
		32432
	],
	"./brands/untappd.svg": [
		31765,
		31765
	],
	"./brands/ups.svg": [
		93627,
		93627
	],
	"./brands/usb.svg": [
		8709,
		8709
	],
	"./brands/usps.svg": [
		40268,
		40268
	],
	"./brands/ussunnah.svg": [
		67864,
		67864
	],
	"./brands/vaadin.svg": [
		71675,
		71675
	],
	"./brands/viacoin.svg": [
		17690,
		17690
	],
	"./brands/viadeo.svg": [
		9404,
		9404
	],
	"./brands/viber.svg": [
		19962,
		19962
	],
	"./brands/vimeo-v.svg": [
		40738,
		40738
	],
	"./brands/vimeo.svg": [
		84179,
		84179
	],
	"./brands/vine.svg": [
		30315,
		30315
	],
	"./brands/vk.svg": [
		3912,
		3912
	],
	"./brands/vnv.svg": [
		89274,
		89274
	],
	"./brands/vuejs.svg": [
		98886,
		98886
	],
	"./brands/watchman-monitoring.svg": [
		88057,
		88057
	],
	"./brands/waze.svg": [
		86881,
		86881
	],
	"./brands/weebly.svg": [
		50249,
		50249
	],
	"./brands/weibo.svg": [
		36155,
		36155
	],
	"./brands/weixin.svg": [
		48951,
		48951
	],
	"./brands/whatsapp.svg": [
		18554,
		18554
	],
	"./brands/whmcs.svg": [
		11036,
		11036
	],
	"./brands/wikipedia-w.svg": [
		4503,
		4503
	],
	"./brands/windows.svg": [
		93175,
		93175
	],
	"./brands/wirsindhandwerk.svg": [
		36786,
		36786
	],
	"./brands/wix.svg": [
		75588,
		75588
	],
	"./brands/wizards-of-the-coast.svg": [
		71005,
		71005
	],
	"./brands/wodu.svg": [
		71371,
		71371
	],
	"./brands/wolf-pack-battalion.svg": [
		59393,
		59393
	],
	"./brands/wordpress-simple.svg": [
		35728,
		35728
	],
	"./brands/wordpress.svg": [
		7390,
		7390
	],
	"./brands/wpbeginner.svg": [
		66771,
		66771
	],
	"./brands/wpexplorer.svg": [
		93807,
		93807
	],
	"./brands/wpforms.svg": [
		37419,
		37419
	],
	"./brands/wpressr.svg": [
		59579,
		59579
	],
	"./brands/xbox.svg": [
		81724,
		81724
	],
	"./brands/xing.svg": [
		68842,
		71948
	],
	"./brands/y-combinator.svg": [
		17979,
		17979
	],
	"./brands/yahoo.svg": [
		9964,
		9964
	],
	"./brands/yammer.svg": [
		29555,
		29555
	],
	"./brands/yandex-international.svg": [
		46325,
		46325
	],
	"./brands/yandex.svg": [
		34742,
		34742
	],
	"./brands/yarn.svg": [
		58959,
		58959
	],
	"./brands/yelp.svg": [
		72270,
		72270
	],
	"./brands/yoast.svg": [
		12812,
		12812
	],
	"./brands/youtube.svg": [
		2824,
		2824
	],
	"./brands/zhihu.svg": [
		2269,
		2269
	],
	"./regular/address-book.svg": [
		65682,
		65682
	],
	"./regular/address-card.svg": [
		7748,
		7748
	],
	"./regular/bell-slash.svg": [
		98170,
		98170
	],
	"./regular/bell.svg": [
		59575,
		59575
	],
	"./regular/bookmark.svg": [
		6653,
		6653
	],
	"./regular/building.svg": [
		8266,
		8266
	],
	"./regular/calendar-check.svg": [
		51776,
		51776
	],
	"./regular/calendar-days.svg": [
		86273,
		86273
	],
	"./regular/calendar-minus.svg": [
		35198,
		35198
	],
	"./regular/calendar-plus.svg": [
		48962,
		48962
	],
	"./regular/calendar-xmark.svg": [
		94730,
		94730
	],
	"./regular/calendar.svg": [
		86468,
		86468
	],
	"./regular/chart-bar.svg": [
		28256,
		28256
	],
	"./regular/chess-bishop.svg": [
		46732,
		46732
	],
	"./regular/chess-king.svg": [
		70720,
		70720
	],
	"./regular/chess-knight.svg": [
		6615,
		6615
	],
	"./regular/chess-pawn.svg": [
		47483,
		47483
	],
	"./regular/chess-queen.svg": [
		50160,
		50160
	],
	"./regular/chess-rook.svg": [
		5448,
		5448
	],
	"./regular/circle-check.svg": [
		79537,
		79537
	],
	"./regular/circle-dot.svg": [
		42057,
		42057
	],
	"./regular/circle-down.svg": [
		15594,
		15594
	],
	"./regular/circle-left.svg": [
		52327,
		52327
	],
	"./regular/circle-pause.svg": [
		7779,
		7779
	],
	"./regular/circle-play.svg": [
		61162,
		61162
	],
	"./regular/circle-question.svg": [
		55986,
		55986
	],
	"./regular/circle-right.svg": [
		55107,
		55107
	],
	"./regular/circle-stop.svg": [
		34727,
		34727
	],
	"./regular/circle-up.svg": [
		17833,
		17833
	],
	"./regular/circle-user.svg": [
		31979,
		31979
	],
	"./regular/circle-xmark.svg": [
		64937,
		64937
	],
	"./regular/circle.svg": [
		17801,
		17801
	],
	"./regular/clipboard.svg": [
		63904,
		63904
	],
	"./regular/clock.svg": [
		82450,
		82450
	],
	"./regular/clone.svg": [
		63102,
		63102
	],
	"./regular/closed-captioning.svg": [
		26547,
		26547
	],
	"./regular/comment-dots.svg": [
		94128,
		94128
	],
	"./regular/comment.svg": [
		15656,
		15656
	],
	"./regular/comments.svg": [
		22393,
		22393
	],
	"./regular/compass.svg": [
		99563,
		99563
	],
	"./regular/copy.svg": [
		54830,
		54830
	],
	"./regular/copyright.svg": [
		99621,
		99621
	],
	"./regular/credit-card.svg": [
		90816,
		90816
	],
	"./regular/envelope-open.svg": [
		33555,
		33555
	],
	"./regular/envelope.svg": [
		93990,
		93990
	],
	"./regular/eye-slash.svg": [
		76861,
		76861
	],
	"./regular/eye.svg": [
		85318,
		85318
	],
	"./regular/face-angry.svg": [
		24824,
		24824
	],
	"./regular/face-dizzy.svg": [
		3478,
		3478
	],
	"./regular/face-flushed.svg": [
		23277,
		23277
	],
	"./regular/face-frown-open.svg": [
		31308,
		31308
	],
	"./regular/face-frown.svg": [
		45389,
		45389
	],
	"./regular/face-grimace.svg": [
		64358,
		64358
	],
	"./regular/face-grin-beam-sweat.svg": [
		81122,
		81122
	],
	"./regular/face-grin-beam.svg": [
		59236,
		59236
	],
	"./regular/face-grin-hearts.svg": [
		57949,
		57949
	],
	"./regular/face-grin-squint-tears.svg": [
		42434,
		42434
	],
	"./regular/face-grin-squint.svg": [
		18990,
		18990
	],
	"./regular/face-grin-stars.svg": [
		40184,
		40184
	],
	"./regular/face-grin-tears.svg": [
		77346,
		77346
	],
	"./regular/face-grin-tongue-squint.svg": [
		33779,
		33779
	],
	"./regular/face-grin-tongue-wink.svg": [
		96105,
		96105
	],
	"./regular/face-grin-tongue.svg": [
		67093,
		67093
	],
	"./regular/face-grin-wide.svg": [
		45746,
		45746
	],
	"./regular/face-grin-wink.svg": [
		71303,
		71303
	],
	"./regular/face-grin.svg": [
		79170,
		79170
	],
	"./regular/face-kiss-beam.svg": [
		77576,
		77576
	],
	"./regular/face-kiss-wink-heart.svg": [
		75154,
		75154
	],
	"./regular/face-kiss.svg": [
		42234,
		42234
	],
	"./regular/face-laugh-beam.svg": [
		45251,
		45251
	],
	"./regular/face-laugh-squint.svg": [
		760,
		760
	],
	"./regular/face-laugh-wink.svg": [
		63069,
		63069
	],
	"./regular/face-laugh.svg": [
		67163,
		67163
	],
	"./regular/face-meh-blank.svg": [
		36751,
		36751
	],
	"./regular/face-meh.svg": [
		18252,
		18252
	],
	"./regular/face-rolling-eyes.svg": [
		38544,
		31702
	],
	"./regular/face-sad-cry.svg": [
		40221,
		40221
	],
	"./regular/face-sad-tear.svg": [
		61721,
		61721
	],
	"./regular/face-smile-beam.svg": [
		80054,
		80054
	],
	"./regular/face-smile-wink.svg": [
		94713,
		94713
	],
	"./regular/face-smile.svg": [
		17638,
		17638
	],
	"./regular/face-surprise.svg": [
		22397,
		22397
	],
	"./regular/face-tired.svg": [
		95617,
		95617
	],
	"./regular/file-audio.svg": [
		88752,
		88752
	],
	"./regular/file-code.svg": [
		13629,
		13629
	],
	"./regular/file-excel.svg": [
		65275,
		65275
	],
	"./regular/file-image.svg": [
		87576,
		87576
	],
	"./regular/file-lines.svg": [
		23008,
		23008
	],
	"./regular/file-pdf.svg": [
		61283,
		61283
	],
	"./regular/file-powerpoint.svg": [
		62270,
		62270
	],
	"./regular/file-video.svg": [
		77456,
		77456
	],
	"./regular/file-word.svg": [
		92234,
		92234
	],
	"./regular/file-zipper.svg": [
		70822,
		70822
	],
	"./regular/file.svg": [
		59223,
		59223
	],
	"./regular/flag.svg": [
		61216,
		61216
	],
	"./regular/floppy-disk.svg": [
		14055,
		14055
	],
	"./regular/folder-closed.svg": [
		34480,
		34480
	],
	"./regular/folder-open.svg": [
		94482,
		94482
	],
	"./regular/folder.svg": [
		91315,
		91315
	],
	"./regular/font-awesome.svg": [
		21588,
		21588
	],
	"./regular/futbol.svg": [
		20633,
		20633
	],
	"./regular/gem.svg": [
		84600,
		84600
	],
	"./regular/hand-back-fist.svg": [
		23288,
		23288
	],
	"./regular/hand-lizard.svg": [
		48641,
		48641
	],
	"./regular/hand-peace.svg": [
		13182,
		13182
	],
	"./regular/hand-point-down.svg": [
		60711,
		60711
	],
	"./regular/hand-point-left.svg": [
		58022,
		58022
	],
	"./regular/hand-point-right.svg": [
		40737,
		40737
	],
	"./regular/hand-point-up.svg": [
		64,
		71108
	],
	"./regular/hand-pointer.svg": [
		87388,
		99252
	],
	"./regular/hand-scissors.svg": [
		21032,
		21032
	],
	"./regular/hand-spock.svg": [
		12816,
		12816
	],
	"./regular/hand.svg": [
		30289,
		30289
	],
	"./regular/handshake.svg": [
		97624,
		97624
	],
	"./regular/hard-drive.svg": [
		74297,
		74297
	],
	"./regular/heart.svg": [
		24504,
		24504
	],
	"./regular/hospital.svg": [
		60777,
		60777
	],
	"./regular/hourglass-half.svg": [
		38594,
		38594
	],
	"./regular/hourglass.svg": [
		64021,
		64021
	],
	"./regular/id-badge.svg": [
		29149,
		29149
	],
	"./regular/id-card.svg": [
		89794,
		80052
	],
	"./regular/image.svg": [
		10952,
		10952
	],
	"./regular/images.svg": [
		46774,
		46774
	],
	"./regular/keyboard.svg": [
		42976,
		42976
	],
	"./regular/lemon.svg": [
		31876,
		31876
	],
	"./regular/life-ring.svg": [
		86177,
		86177
	],
	"./regular/lightbulb.svg": [
		95797,
		59428
	],
	"./regular/map.svg": [
		80509,
		80509
	],
	"./regular/message.svg": [
		9799,
		86583
	],
	"./regular/money-bill-1.svg": [
		30850,
		30850
	],
	"./regular/moon.svg": [
		46281,
		46281
	],
	"./regular/newspaper.svg": [
		36718,
		36718
	],
	"./regular/note-sticky.svg": [
		74861,
		74861
	],
	"./regular/object-group.svg": [
		80174,
		80174
	],
	"./regular/object-ungroup.svg": [
		62534,
		62534
	],
	"./regular/paper-plane.svg": [
		68855,
		68855
	],
	"./regular/paste.svg": [
		94968,
		94968
	],
	"./regular/pen-to-square.svg": [
		82434,
		82434
	],
	"./regular/rectangle-list.svg": [
		51629,
		51629
	],
	"./regular/rectangle-xmark.svg": [
		51273,
		51273
	],
	"./regular/registered.svg": [
		3029,
		3029
	],
	"./regular/share-from-square.svg": [
		23658,
		23658
	],
	"./regular/snowflake.svg": [
		5912,
		9006
	],
	"./regular/square-caret-down.svg": [
		13949,
		13949
	],
	"./regular/square-caret-left.svg": [
		66619,
		66619
	],
	"./regular/square-caret-right.svg": [
		23389,
		23389
	],
	"./regular/square-caret-up.svg": [
		81187,
		81187
	],
	"./regular/square-check.svg": [
		44155,
		44155
	],
	"./regular/square-full.svg": [
		9710,
		9710
	],
	"./regular/square-minus.svg": [
		9597,
		9597
	],
	"./regular/square-plus.svg": [
		72221,
		72221
	],
	"./regular/square.svg": [
		59231,
		59231
	],
	"./regular/star-half-stroke.svg": [
		44533,
		44533
	],
	"./regular/star-half.svg": [
		49053,
		49053
	],
	"./regular/star.svg": [
		70258,
		70258
	],
	"./regular/sun.svg": [
		16084,
		16084
	],
	"./regular/thumbs-down.svg": [
		53925,
		53925
	],
	"./regular/thumbs-up.svg": [
		70968,
		70968
	],
	"./regular/trash-can.svg": [
		72024,
		72024
	],
	"./regular/user.svg": [
		18482,
		18482
	],
	"./regular/window-maximize.svg": [
		43270,
		43270
	],
	"./regular/window-minimize.svg": [
		27596,
		27596
	],
	"./regular/window-restore.svg": [
		58765,
		58765
	],
	"./solid/0.svg": [
		87347,
		87347
	],
	"./solid/1.svg": [
		93364,
		93364
	],
	"./solid/2.svg": [
		24495,
		24495
	],
	"./solid/3.svg": [
		10591,
		10591
	],
	"./solid/4.svg": [
		88652,
		88652
	],
	"./solid/5.svg": [
		45576,
		45576
	],
	"./solid/6.svg": [
		70411,
		70411
	],
	"./solid/7.svg": [
		6321,
		6321
	],
	"./solid/8.svg": [
		72425,
		72425
	],
	"./solid/9.svg": [
		94491,
		94491
	],
	"./solid/a.svg": [
		36957,
		36957
	],
	"./solid/address-book.svg": [
		97514,
		97514
	],
	"./solid/address-card.svg": [
		82382,
		82382
	],
	"./solid/align-center.svg": [
		68277,
		68277
	],
	"./solid/align-justify.svg": [
		17481,
		17481
	],
	"./solid/align-left.svg": [
		64788,
		64788
	],
	"./solid/align-right.svg": [
		60068,
		60068
	],
	"./solid/anchor-circle-check.svg": [
		32466,
		32466
	],
	"./solid/anchor-circle-exclamation.svg": [
		69399,
		69399
	],
	"./solid/anchor-circle-xmark.svg": [
		65585,
		65585
	],
	"./solid/anchor-lock.svg": [
		86568,
		86568
	],
	"./solid/anchor.svg": [
		86128,
		86128
	],
	"./solid/angle-down.svg": [
		90649,
		90649
	],
	"./solid/angle-left.svg": [
		16869,
		16869
	],
	"./solid/angle-right.svg": [
		5790,
		5790
	],
	"./solid/angle-up.svg": [
		81588,
		81588
	],
	"./solid/angles-down.svg": [
		79775,
		79775
	],
	"./solid/angles-left.svg": [
		48794,
		48794
	],
	"./solid/angles-right.svg": [
		83297,
		83297
	],
	"./solid/angles-up.svg": [
		37406,
		37406
	],
	"./solid/ankh.svg": [
		50183,
		50183
	],
	"./solid/apple-whole.svg": [
		43753,
		43753
	],
	"./solid/archway.svg": [
		662,
		662
	],
	"./solid/arrow-down-1-9.svg": [
		35912,
		35912
	],
	"./solid/arrow-down-9-1.svg": [
		11948,
		48743
	],
	"./solid/arrow-down-a-z.svg": [
		46472,
		46472
	],
	"./solid/arrow-down-long.svg": [
		24181,
		24181
	],
	"./solid/arrow-down-short-wide.svg": [
		23323,
		23323
	],
	"./solid/arrow-down-up-across-line.svg": [
		90563,
		90563
	],
	"./solid/arrow-down-up-lock.svg": [
		31474,
		31474
	],
	"./solid/arrow-down-wide-short.svg": [
		89619,
		89619
	],
	"./solid/arrow-down-z-a.svg": [
		97381,
		97381
	],
	"./solid/arrow-down.svg": [
		1635,
		1635
	],
	"./solid/arrow-left-long.svg": [
		31180,
		31180
	],
	"./solid/arrow-left.svg": [
		24553,
		24553
	],
	"./solid/arrow-pointer.svg": [
		75761,
		75761
	],
	"./solid/arrow-right-arrow-left.svg": [
		61861,
		61861
	],
	"./solid/arrow-right-from-bracket.svg": [
		30043,
		30043
	],
	"./solid/arrow-right-long.svg": [
		48611,
		48611
	],
	"./solid/arrow-right-to-bracket.svg": [
		85805,
		85805
	],
	"./solid/arrow-right-to-city.svg": [
		49166,
		49166
	],
	"./solid/arrow-right.svg": [
		56018,
		56018
	],
	"./solid/arrow-rotate-left.svg": [
		37622,
		71475
	],
	"./solid/arrow-rotate-right.svg": [
		71126,
		71126
	],
	"./solid/arrow-trend-down.svg": [
		23372,
		23372
	],
	"./solid/arrow-trend-up.svg": [
		87784,
		87784
	],
	"./solid/arrow-turn-down.svg": [
		86052,
		86052
	],
	"./solid/arrow-turn-up.svg": [
		69813,
		69813
	],
	"./solid/arrow-up-1-9.svg": [
		70052,
		70052
	],
	"./solid/arrow-up-9-1.svg": [
		24435,
		24435
	],
	"./solid/arrow-up-a-z.svg": [
		6809,
		6809
	],
	"./solid/arrow-up-from-bracket.svg": [
		41720,
		41720
	],
	"./solid/arrow-up-from-ground-water.svg": [
		35757,
		35757
	],
	"./solid/arrow-up-from-water-pump.svg": [
		35825,
		37622
	],
	"./solid/arrow-up-long.svg": [
		43302,
		43302
	],
	"./solid/arrow-up-right-dots.svg": [
		29821,
		29821
	],
	"./solid/arrow-up-right-from-square.svg": [
		18822,
		18822
	],
	"./solid/arrow-up-short-wide.svg": [
		25895,
		25895
	],
	"./solid/arrow-up-wide-short.svg": [
		17483,
		17483
	],
	"./solid/arrow-up-z-a.svg": [
		30753,
		30753
	],
	"./solid/arrow-up.svg": [
		49946,
		49946
	],
	"./solid/arrows-down-to-line.svg": [
		36227,
		36227
	],
	"./solid/arrows-down-to-people.svg": [
		17159,
		17159
	],
	"./solid/arrows-left-right-to-line.svg": [
		67632,
		67632
	],
	"./solid/arrows-left-right.svg": [
		6303,
		6303
	],
	"./solid/arrows-rotate.svg": [
		17822,
		17822
	],
	"./solid/arrows-spin.svg": [
		83854,
		83854
	],
	"./solid/arrows-split-up-and-left.svg": [
		45664,
		45664
	],
	"./solid/arrows-to-circle.svg": [
		4372,
		4372
	],
	"./solid/arrows-to-dot.svg": [
		49705,
		49705
	],
	"./solid/arrows-to-eye.svg": [
		92374,
		92374
	],
	"./solid/arrows-turn-right.svg": [
		96192,
		96192
	],
	"./solid/arrows-turn-to-dots.svg": [
		34512,
		34512
	],
	"./solid/arrows-up-down-left-right.svg": [
		53962,
		53962
	],
	"./solid/arrows-up-down.svg": [
		70388,
		70388
	],
	"./solid/arrows-up-to-line.svg": [
		54501,
		54501
	],
	"./solid/asterisk.svg": [
		23635,
		23635
	],
	"./solid/at.svg": [
		91284,
		91284
	],
	"./solid/atom.svg": [
		60168,
		60168
	],
	"./solid/audio-description.svg": [
		57889,
		57889
	],
	"./solid/austral-sign.svg": [
		66163,
		66163
	],
	"./solid/award.svg": [
		65307,
		67560
	],
	"./solid/b.svg": [
		60866,
		60866
	],
	"./solid/baby-carriage.svg": [
		59788,
		59788
	],
	"./solid/baby.svg": [
		27471,
		27471
	],
	"./solid/backward-fast.svg": [
		82453,
		82453
	],
	"./solid/backward-step.svg": [
		98071,
		98071
	],
	"./solid/backward.svg": [
		58598,
		58598
	],
	"./solid/bacon.svg": [
		56020,
		56020
	],
	"./solid/bacteria.svg": [
		32935,
		32935
	],
	"./solid/bacterium.svg": [
		10769,
		10769
	],
	"./solid/bag-shopping.svg": [
		90001,
		39869
	],
	"./solid/bahai.svg": [
		27502,
		27502
	],
	"./solid/baht-sign.svg": [
		83407,
		83407
	],
	"./solid/ban-smoking.svg": [
		76659,
		76659
	],
	"./solid/ban.svg": [
		4212,
		4212
	],
	"./solid/bandage.svg": [
		2453,
		2453
	],
	"./solid/bangladeshi-taka-sign.svg": [
		99887,
		99887
	],
	"./solid/barcode.svg": [
		2059,
		2059
	],
	"./solid/bars-progress.svg": [
		21431,
		21431
	],
	"./solid/bars-staggered.svg": [
		78492,
		78492
	],
	"./solid/bars.svg": [
		62654,
		62654
	],
	"./solid/baseball-bat-ball.svg": [
		17443,
		17443
	],
	"./solid/baseball.svg": [
		90787,
		90787
	],
	"./solid/basket-shopping.svg": [
		13248,
		13248
	],
	"./solid/basketball.svg": [
		56130,
		56130
	],
	"./solid/bath.svg": [
		48620,
		48620
	],
	"./solid/battery-empty.svg": [
		55056,
		55056
	],
	"./solid/battery-full.svg": [
		95699,
		95699
	],
	"./solid/battery-half.svg": [
		91272,
		91272
	],
	"./solid/battery-quarter.svg": [
		67836,
		67836
	],
	"./solid/battery-three-quarters.svg": [
		95575,
		95575
	],
	"./solid/bed-pulse.svg": [
		84396,
		84396
	],
	"./solid/bed.svg": [
		63226,
		63226
	],
	"./solid/beer-mug-empty.svg": [
		33624,
		33624
	],
	"./solid/bell-concierge.svg": [
		97349,
		97349
	],
	"./solid/bell-slash.svg": [
		37927,
		37927
	],
	"./solid/bell.svg": [
		59090,
		59090
	],
	"./solid/bezier-curve.svg": [
		80379,
		80379
	],
	"./solid/bicycle.svg": [
		82590,
		82590
	],
	"./solid/binoculars.svg": [
		2735,
		2735
	],
	"./solid/biohazard.svg": [
		14315,
		14315
	],
	"./solid/bitcoin-sign.svg": [
		48145,
		48145
	],
	"./solid/blender-phone.svg": [
		48945,
		48945
	],
	"./solid/blender.svg": [
		46648,
		46648
	],
	"./solid/blog.svg": [
		3294,
		3294
	],
	"./solid/bold.svg": [
		52713,
		52713
	],
	"./solid/bolt-lightning.svg": [
		357,
		357
	],
	"./solid/bolt.svg": [
		32448,
		32448
	],
	"./solid/bomb.svg": [
		57007,
		57007
	],
	"./solid/bone.svg": [
		67394,
		67394
	],
	"./solid/bong.svg": [
		33406,
		33406
	],
	"./solid/book-atlas.svg": [
		68762,
		68762
	],
	"./solid/book-bible.svg": [
		33886,
		33886
	],
	"./solid/book-bookmark.svg": [
		63325,
		63325
	],
	"./solid/book-journal-whills.svg": [
		64465,
		64465
	],
	"./solid/book-medical.svg": [
		39907,
		39907
	],
	"./solid/book-open-reader.svg": [
		62573,
		62573
	],
	"./solid/book-open.svg": [
		94504,
		94504
	],
	"./solid/book-quran.svg": [
		76714,
		76714
	],
	"./solid/book-skull.svg": [
		25068,
		25068
	],
	"./solid/book-tanakh.svg": [
		16532,
		16532
	],
	"./solid/book.svg": [
		46666,
		46666
	],
	"./solid/bookmark.svg": [
		46598,
		46598
	],
	"./solid/border-all.svg": [
		87539,
		87539
	],
	"./solid/border-none.svg": [
		94310,
		94310
	],
	"./solid/border-top-left.svg": [
		25228,
		25228
	],
	"./solid/bore-hole.svg": [
		80467,
		80467
	],
	"./solid/bottle-droplet.svg": [
		61036,
		61036
	],
	"./solid/bottle-water.svg": [
		26967,
		26967
	],
	"./solid/bowl-food.svg": [
		28491,
		28491
	],
	"./solid/bowl-rice.svg": [
		64326,
		64326
	],
	"./solid/bowling-ball.svg": [
		58477,
		58477
	],
	"./solid/box-archive.svg": [
		38437,
		38437
	],
	"./solid/box-open.svg": [
		88947,
		94686
	],
	"./solid/box-tissue.svg": [
		24689,
		24689
	],
	"./solid/box.svg": [
		12031,
		12031
	],
	"./solid/boxes-packing.svg": [
		74623,
		74623
	],
	"./solid/boxes-stacked.svg": [
		69739,
		69739
	],
	"./solid/braille.svg": [
		87637,
		87637
	],
	"./solid/brain.svg": [
		27581,
		27581
	],
	"./solid/brazilian-real-sign.svg": [
		780,
		780
	],
	"./solid/bread-slice.svg": [
		1152,
		1152
	],
	"./solid/bridge-circle-check.svg": [
		15475,
		15475
	],
	"./solid/bridge-circle-exclamation.svg": [
		48680,
		48680
	],
	"./solid/bridge-circle-xmark.svg": [
		44270,
		44270
	],
	"./solid/bridge-lock.svg": [
		26397,
		26397
	],
	"./solid/bridge-water.svg": [
		52312,
		52312
	],
	"./solid/bridge.svg": [
		86938,
		86938
	],
	"./solid/briefcase-medical.svg": [
		82828,
		82828
	],
	"./solid/briefcase.svg": [
		90373,
		90373
	],
	"./solid/broom-ball.svg": [
		5106,
		5106
	],
	"./solid/broom.svg": [
		38988,
		38988
	],
	"./solid/brush.svg": [
		41375,
		41375
	],
	"./solid/bucket.svg": [
		22036,
		22036
	],
	"./solid/bug-slash.svg": [
		52110,
		52110
	],
	"./solid/bug.svg": [
		21291,
		21291
	],
	"./solid/bugs.svg": [
		90950,
		90950
	],
	"./solid/building-circle-arrow-right.svg": [
		58889,
		58889
	],
	"./solid/building-circle-check.svg": [
		172,
		172
	],
	"./solid/building-circle-exclamation.svg": [
		67302,
		67302
	],
	"./solid/building-circle-xmark.svg": [
		5133,
		5133
	],
	"./solid/building-columns.svg": [
		93772,
		93772
	],
	"./solid/building-flag.svg": [
		34257,
		34257
	],
	"./solid/building-lock.svg": [
		77590,
		77590
	],
	"./solid/building-ngo.svg": [
		83734,
		83734
	],
	"./solid/building-shield.svg": [
		39893,
		39893
	],
	"./solid/building-un.svg": [
		27462,
		27462
	],
	"./solid/building-user.svg": [
		59080,
		59080
	],
	"./solid/building-wheat.svg": [
		98632,
		98632
	],
	"./solid/building.svg": [
		79604,
		79604
	],
	"./solid/bullhorn.svg": [
		2557,
		2557
	],
	"./solid/bullseye.svg": [
		5523,
		5523
	],
	"./solid/burger.svg": [
		91655,
		91655
	],
	"./solid/burst.svg": [
		91097,
		91097
	],
	"./solid/bus-simple.svg": [
		6817,
		6817
	],
	"./solid/bus.svg": [
		26082,
		26082
	],
	"./solid/business-time.svg": [
		15200,
		15200
	],
	"./solid/c.svg": [
		16788,
		16788
	],
	"./solid/cable-car.svg": [
		52680,
		52680
	],
	"./solid/cake-candles.svg": [
		19326,
		19326
	],
	"./solid/calculator.svg": [
		32632,
		32632
	],
	"./solid/calendar-check.svg": [
		96449,
		96449
	],
	"./solid/calendar-day.svg": [
		64417,
		64417
	],
	"./solid/calendar-days.svg": [
		55251,
		55251
	],
	"./solid/calendar-minus.svg": [
		30366,
		30366
	],
	"./solid/calendar-plus.svg": [
		36722,
		36722
	],
	"./solid/calendar-week.svg": [
		48012,
		48012
	],
	"./solid/calendar-xmark.svg": [
		17981,
		17981
	],
	"./solid/calendar.svg": [
		94297,
		77234
	],
	"./solid/camera-retro.svg": [
		6406,
		6406
	],
	"./solid/camera-rotate.svg": [
		27202,
		27202
	],
	"./solid/camera.svg": [
		49604,
		49604
	],
	"./solid/campground.svg": [
		33755,
		33755
	],
	"./solid/candy-cane.svg": [
		82086,
		82086
	],
	"./solid/cannabis.svg": [
		93267,
		93267
	],
	"./solid/capsules.svg": [
		59565,
		59565
	],
	"./solid/car-battery.svg": [
		63330,
		63330
	],
	"./solid/car-burst.svg": [
		53399,
		53399
	],
	"./solid/car-on.svg": [
		88683,
		88683
	],
	"./solid/car-rear.svg": [
		9111,
		9111
	],
	"./solid/car-side.svg": [
		58459,
		58459
	],
	"./solid/car-tunnel.svg": [
		80421,
		80421
	],
	"./solid/car.svg": [
		83071,
		83071
	],
	"./solid/caravan.svg": [
		51382,
		51382
	],
	"./solid/caret-down.svg": [
		90630,
		90630
	],
	"./solid/caret-left.svg": [
		7401,
		7401
	],
	"./solid/caret-right.svg": [
		99687,
		99687
	],
	"./solid/caret-up.svg": [
		52455,
		52455
	],
	"./solid/carrot.svg": [
		25017,
		25017
	],
	"./solid/cart-arrow-down.svg": [
		84946,
		84946
	],
	"./solid/cart-flatbed-suitcase.svg": [
		78461,
		78461
	],
	"./solid/cart-flatbed.svg": [
		76094,
		76094
	],
	"./solid/cart-plus.svg": [
		46618,
		46618
	],
	"./solid/cart-shopping.svg": [
		76229,
		76229
	],
	"./solid/cash-register.svg": [
		37152,
		37152
	],
	"./solid/cat.svg": [
		86171,
		86171
	],
	"./solid/cedi-sign.svg": [
		43199,
		43199
	],
	"./solid/cent-sign.svg": [
		13159,
		13159
	],
	"./solid/certificate.svg": [
		21564,
		21564
	],
	"./solid/chair.svg": [
		13752,
		13752
	],
	"./solid/chalkboard-user.svg": [
		68806,
		68806
	],
	"./solid/chalkboard.svg": [
		45731,
		45731
	],
	"./solid/champagne-glasses.svg": [
		5760,
		5760
	],
	"./solid/charging-station.svg": [
		18506,
		18506
	],
	"./solid/chart-area.svg": [
		97329,
		97329
	],
	"./solid/chart-bar.svg": [
		79611,
		79611
	],
	"./solid/chart-column.svg": [
		81683,
		81683
	],
	"./solid/chart-gantt.svg": [
		5744,
		5744
	],
	"./solid/chart-line.svg": [
		99740,
		99740
	],
	"./solid/chart-pie.svg": [
		54579,
		54579
	],
	"./solid/chart-simple.svg": [
		37613,
		37613
	],
	"./solid/check-double.svg": [
		37233,
		37233
	],
	"./solid/check-to-slot.svg": [
		67649,
		67649
	],
	"./solid/check.svg": [
		22764,
		22764
	],
	"./solid/cheese.svg": [
		8710,
		8710
	],
	"./solid/chess-bishop.svg": [
		88487,
		88487
	],
	"./solid/chess-board.svg": [
		65987,
		65987
	],
	"./solid/chess-king.svg": [
		93714,
		93714
	],
	"./solid/chess-knight.svg": [
		69408,
		69408
	],
	"./solid/chess-pawn.svg": [
		40843,
		40843
	],
	"./solid/chess-queen.svg": [
		26539,
		26539
	],
	"./solid/chess-rook.svg": [
		13022,
		13022
	],
	"./solid/chess.svg": [
		50325,
		50325
	],
	"./solid/chevron-down.svg": [
		76898,
		76898
	],
	"./solid/chevron-left.svg": [
		82923,
		82923
	],
	"./solid/chevron-right.svg": [
		38522,
		38522
	],
	"./solid/chevron-up.svg": [
		24075,
		24075
	],
	"./solid/child-combatant.svg": [
		28630,
		28630
	],
	"./solid/child-dress.svg": [
		29059,
		29059
	],
	"./solid/child-reaching.svg": [
		27960,
		27960
	],
	"./solid/child.svg": [
		49698,
		49698
	],
	"./solid/children.svg": [
		49059,
		49059
	],
	"./solid/church.svg": [
		85952,
		85952
	],
	"./solid/circle-arrow-down.svg": [
		44536,
		44536
	],
	"./solid/circle-arrow-left.svg": [
		99343,
		99343
	],
	"./solid/circle-arrow-right.svg": [
		45001,
		45001
	],
	"./solid/circle-arrow-up.svg": [
		73561,
		73561
	],
	"./solid/circle-check.svg": [
		65170,
		65170
	],
	"./solid/circle-chevron-down.svg": [
		42296,
		42296
	],
	"./solid/circle-chevron-left.svg": [
		78394,
		78394
	],
	"./solid/circle-chevron-right.svg": [
		54541,
		54541
	],
	"./solid/circle-chevron-up.svg": [
		6938,
		6938
	],
	"./solid/circle-dollar-to-slot.svg": [
		49415,
		49415
	],
	"./solid/circle-dot.svg": [
		3098,
		3098
	],
	"./solid/circle-down.svg": [
		53130,
		99878
	],
	"./solid/circle-exclamation.svg": [
		39375,
		39375
	],
	"./solid/circle-h.svg": [
		49518,
		49518
	],
	"./solid/circle-half-stroke.svg": [
		85784,
		85784
	],
	"./solid/circle-info.svg": [
		3970,
		3970
	],
	"./solid/circle-left.svg": [
		52645,
		52645
	],
	"./solid/circle-minus.svg": [
		32241,
		4675
	],
	"./solid/circle-nodes.svg": [
		52857,
		52857
	],
	"./solid/circle-notch.svg": [
		93926,
		93926
	],
	"./solid/circle-pause.svg": [
		29847,
		29847
	],
	"./solid/circle-play.svg": [
		50085,
		61937
	],
	"./solid/circle-plus.svg": [
		41506,
		41506
	],
	"./solid/circle-question.svg": [
		88552,
		88552
	],
	"./solid/circle-radiation.svg": [
		79565,
		79565
	],
	"./solid/circle-right.svg": [
		4076,
		4076
	],
	"./solid/circle-stop.svg": [
		34254,
		34254
	],
	"./solid/circle-up.svg": [
		61426,
		61426
	],
	"./solid/circle-user.svg": [
		92591,
		92591
	],
	"./solid/circle-xmark.svg": [
		96491,
		96491
	],
	"./solid/circle.svg": [
		57939,
		57939
	],
	"./solid/city.svg": [
		66528,
		66528
	],
	"./solid/clapperboard.svg": [
		81488,
		81488
	],
	"./solid/clipboard-check.svg": [
		49634,
		49634
	],
	"./solid/clipboard-list.svg": [
		50530,
		50530
	],
	"./solid/clipboard-question.svg": [
		14737,
		14737
	],
	"./solid/clipboard-user.svg": [
		76814,
		76814
	],
	"./solid/clipboard.svg": [
		93864,
		93864
	],
	"./solid/clock-rotate-left.svg": [
		5663,
		5663
	],
	"./solid/clock.svg": [
		90912,
		90912
	],
	"./solid/clone.svg": [
		29291,
		29291
	],
	"./solid/closed-captioning.svg": [
		57774,
		57774
	],
	"./solid/cloud-arrow-down.svg": [
		59839,
		59839
	],
	"./solid/cloud-arrow-up.svg": [
		72446,
		72446
	],
	"./solid/cloud-bolt.svg": [
		22405,
		22405
	],
	"./solid/cloud-meatball.svg": [
		6536,
		6536
	],
	"./solid/cloud-moon-rain.svg": [
		38030,
		38030
	],
	"./solid/cloud-moon.svg": [
		6478,
		6478
	],
	"./solid/cloud-rain.svg": [
		76227,
		76227
	],
	"./solid/cloud-showers-heavy.svg": [
		35060,
		35060
	],
	"./solid/cloud-showers-water.svg": [
		16125,
		16125
	],
	"./solid/cloud-sun-rain.svg": [
		14010,
		14010
	],
	"./solid/cloud-sun.svg": [
		80005,
		80005
	],
	"./solid/cloud.svg": [
		850,
		850
	],
	"./solid/clover.svg": [
		38223,
		38223
	],
	"./solid/code-branch.svg": [
		57308,
		57308
	],
	"./solid/code-commit.svg": [
		29868,
		29868
	],
	"./solid/code-compare.svg": [
		4298,
		4298
	],
	"./solid/code-fork.svg": [
		97187,
		97187
	],
	"./solid/code-merge.svg": [
		47277,
		47277
	],
	"./solid/code-pull-request.svg": [
		28684,
		28684
	],
	"./solid/code.svg": [
		17992,
		17992
	],
	"./solid/coins.svg": [
		87151,
		87151
	],
	"./solid/colon-sign.svg": [
		30637,
		30637
	],
	"./solid/comment-dollar.svg": [
		27730,
		27730
	],
	"./solid/comment-dots.svg": [
		90605,
		90605
	],
	"./solid/comment-medical.svg": [
		50616,
		50616
	],
	"./solid/comment-slash.svg": [
		2043,
		2043
	],
	"./solid/comment-sms.svg": [
		52905,
		52905
	],
	"./solid/comment.svg": [
		17524,
		17524
	],
	"./solid/comments-dollar.svg": [
		39358,
		39358
	],
	"./solid/comments.svg": [
		10970,
		10970
	],
	"./solid/compact-disc.svg": [
		28843,
		28843
	],
	"./solid/compass-drafting.svg": [
		34583,
		34583
	],
	"./solid/compass.svg": [
		29357,
		29357
	],
	"./solid/compress.svg": [
		64853,
		64853
	],
	"./solid/computer-mouse.svg": [
		80723,
		80723
	],
	"./solid/computer.svg": [
		51887,
		51887
	],
	"./solid/cookie-bite.svg": [
		65032,
		65032
	],
	"./solid/cookie.svg": [
		53541,
		53541
	],
	"./solid/copy.svg": [
		720,
		720
	],
	"./solid/copyright.svg": [
		92579,
		92579
	],
	"./solid/couch.svg": [
		19489,
		19489
	],
	"./solid/cow.svg": [
		33865,
		33865
	],
	"./solid/credit-card.svg": [
		59840,
		59840
	],
	"./solid/crop-simple.svg": [
		17187,
		17187
	],
	"./solid/crop.svg": [
		35567,
		35567
	],
	"./solid/cross.svg": [
		95634,
		95634
	],
	"./solid/crosshairs.svg": [
		72746,
		72746
	],
	"./solid/crow.svg": [
		82213,
		82213
	],
	"./solid/crown.svg": [
		77806,
		77806
	],
	"./solid/crutch.svg": [
		64233,
		64233
	],
	"./solid/cruzeiro-sign.svg": [
		60368,
		60368
	],
	"./solid/cube.svg": [
		2226,
		2226
	],
	"./solid/cubes-stacked.svg": [
		64334,
		64334
	],
	"./solid/cubes.svg": [
		3695,
		3695
	],
	"./solid/d.svg": [
		19584,
		19584
	],
	"./solid/database.svg": [
		56658,
		56658
	],
	"./solid/delete-left.svg": [
		29820,
		29820
	],
	"./solid/democrat.svg": [
		64058,
		64058
	],
	"./solid/desktop.svg": [
		44364,
		44364
	],
	"./solid/dharmachakra.svg": [
		10137,
		10137
	],
	"./solid/diagram-next.svg": [
		64112,
		64112
	],
	"./solid/diagram-predecessor.svg": [
		58454,
		58454
	],
	"./solid/diagram-project.svg": [
		89206,
		89206
	],
	"./solid/diagram-successor.svg": [
		59164,
		59164
	],
	"./solid/diamond-turn-right.svg": [
		30533,
		30533
	],
	"./solid/diamond.svg": [
		86714,
		86714
	],
	"./solid/dice-d20.svg": [
		78246,
		78246
	],
	"./solid/dice-d6.svg": [
		60747,
		60747
	],
	"./solid/dice-five.svg": [
		19399,
		19399
	],
	"./solid/dice-four.svg": [
		73529,
		73529
	],
	"./solid/dice-one.svg": [
		65817,
		65817
	],
	"./solid/dice-six.svg": [
		42269,
		42269
	],
	"./solid/dice-three.svg": [
		87274,
		87274
	],
	"./solid/dice-two.svg": [
		14862,
		14862
	],
	"./solid/dice.svg": [
		56699,
		56699
	],
	"./solid/disease.svg": [
		64691,
		64691
	],
	"./solid/display.svg": [
		8986,
		8986
	],
	"./solid/divide.svg": [
		3795,
		3795
	],
	"./solid/dna.svg": [
		6730,
		6730
	],
	"./solid/dog.svg": [
		97345,
		97345
	],
	"./solid/dollar-sign.svg": [
		24507,
		24507
	],
	"./solid/dolly.svg": [
		3324,
		3324
	],
	"./solid/dong-sign.svg": [
		39815,
		39815
	],
	"./solid/door-closed.svg": [
		98649,
		98649
	],
	"./solid/door-open.svg": [
		19621,
		19621
	],
	"./solid/dove.svg": [
		72533,
		72533
	],
	"./solid/down-left-and-up-right-to-center.svg": [
		23884,
		23884
	],
	"./solid/down-long.svg": [
		93380,
		93380
	],
	"./solid/download.svg": [
		2463,
		2463
	],
	"./solid/dragon.svg": [
		66394,
		66394
	],
	"./solid/draw-polygon.svg": [
		18052,
		18052
	],
	"./solid/droplet-slash.svg": [
		51245,
		51245
	],
	"./solid/droplet.svg": [
		63244,
		63244
	],
	"./solid/drum-steelpan.svg": [
		36795,
		36795
	],
	"./solid/drum.svg": [
		98902,
		98902
	],
	"./solid/drumstick-bite.svg": [
		96663,
		96663
	],
	"./solid/dumbbell.svg": [
		17090,
		17090
	],
	"./solid/dumpster-fire.svg": [
		24855,
		24855
	],
	"./solid/dumpster.svg": [
		84775,
		84775
	],
	"./solid/dungeon.svg": [
		6540,
		6540
	],
	"./solid/e.svg": [
		46317,
		46317
	],
	"./solid/ear-deaf.svg": [
		38056,
		38056
	],
	"./solid/ear-listen.svg": [
		1245,
		1245
	],
	"./solid/earth-africa.svg": [
		7293,
		7293
	],
	"./solid/earth-americas.svg": [
		76740,
		76740
	],
	"./solid/earth-asia.svg": [
		50030,
		50030
	],
	"./solid/earth-europe.svg": [
		46641,
		46641
	],
	"./solid/earth-oceania.svg": [
		33618,
		33618
	],
	"./solid/egg.svg": [
		41628,
		41628
	],
	"./solid/eject.svg": [
		69596,
		69596
	],
	"./solid/elevator.svg": [
		55508,
		55508
	],
	"./solid/ellipsis-vertical.svg": [
		68756,
		68756
	],
	"./solid/ellipsis.svg": [
		83962,
		83962
	],
	"./solid/envelope-circle-check.svg": [
		92989,
		92989
	],
	"./solid/envelope-open-text.svg": [
		44579,
		44579
	],
	"./solid/envelope-open.svg": [
		69336,
		69336
	],
	"./solid/envelope.svg": [
		93902,
		93902
	],
	"./solid/envelopes-bulk.svg": [
		60081,
		60081
	],
	"./solid/equals.svg": [
		11245,
		11245
	],
	"./solid/eraser.svg": [
		95166,
		95166
	],
	"./solid/ethernet.svg": [
		14630,
		14630
	],
	"./solid/euro-sign.svg": [
		73211,
		73211
	],
	"./solid/exclamation.svg": [
		13552,
		13552
	],
	"./solid/expand.svg": [
		93092,
		93092
	],
	"./solid/explosion.svg": [
		27119,
		92502
	],
	"./solid/eye-dropper.svg": [
		50195,
		50195
	],
	"./solid/eye-low-vision.svg": [
		16903,
		16903
	],
	"./solid/eye-slash.svg": [
		49843,
		49843
	],
	"./solid/eye.svg": [
		35441,
		35441
	],
	"./solid/f.svg": [
		75237,
		75237
	],
	"./solid/face-angry.svg": [
		41838,
		41838
	],
	"./solid/face-dizzy.svg": [
		30630,
		30630
	],
	"./solid/face-flushed.svg": [
		84613,
		84613
	],
	"./solid/face-frown-open.svg": [
		62926,
		62926
	],
	"./solid/face-frown.svg": [
		37403,
		37403
	],
	"./solid/face-grimace.svg": [
		27698,
		27698
	],
	"./solid/face-grin-beam-sweat.svg": [
		6523,
		6523
	],
	"./solid/face-grin-beam.svg": [
		12654,
		12654
	],
	"./solid/face-grin-hearts.svg": [
		82523,
		82523
	],
	"./solid/face-grin-squint-tears.svg": [
		64774,
		64774
	],
	"./solid/face-grin-squint.svg": [
		144,
		144
	],
	"./solid/face-grin-stars.svg": [
		87283,
		87283
	],
	"./solid/face-grin-tears.svg": [
		43251,
		43251
	],
	"./solid/face-grin-tongue-squint.svg": [
		52373,
		52373
	],
	"./solid/face-grin-tongue-wink.svg": [
		45134,
		45134
	],
	"./solid/face-grin-tongue.svg": [
		72613,
		72613
	],
	"./solid/face-grin-wide.svg": [
		17788,
		17788
	],
	"./solid/face-grin-wink.svg": [
		65947,
		65947
	],
	"./solid/face-grin.svg": [
		33160,
		33160
	],
	"./solid/face-kiss-beam.svg": [
		43693,
		43693
	],
	"./solid/face-kiss-wink-heart.svg": [
		5845,
		5845
	],
	"./solid/face-kiss.svg": [
		97839,
		60429
	],
	"./solid/face-laugh-beam.svg": [
		16360,
		16360
	],
	"./solid/face-laugh-squint.svg": [
		38634,
		38634
	],
	"./solid/face-laugh-wink.svg": [
		77350,
		77350
	],
	"./solid/face-laugh.svg": [
		73537,
		73537
	],
	"./solid/face-meh-blank.svg": [
		92044,
		92044
	],
	"./solid/face-meh.svg": [
		92027,
		92027
	],
	"./solid/face-rolling-eyes.svg": [
		82525,
		82525
	],
	"./solid/face-sad-cry.svg": [
		69421,
		69421
	],
	"./solid/face-sad-tear.svg": [
		16471,
		16471
	],
	"./solid/face-smile-beam.svg": [
		16424,
		16424
	],
	"./solid/face-smile-wink.svg": [
		71231,
		71231
	],
	"./solid/face-smile.svg": [
		958,
		958
	],
	"./solid/face-surprise.svg": [
		9343,
		9343
	],
	"./solid/face-tired.svg": [
		50893,
		50893
	],
	"./solid/fan.svg": [
		9989,
		9989
	],
	"./solid/faucet-drip.svg": [
		17376,
		17376
	],
	"./solid/faucet.svg": [
		11578,
		11578
	],
	"./solid/fax.svg": [
		87606,
		87606
	],
	"./solid/feather-pointed.svg": [
		52667,
		52667
	],
	"./solid/feather.svg": [
		6073,
		6073
	],
	"./solid/ferry.svg": [
		24562,
		24562
	],
	"./solid/file-arrow-down.svg": [
		98919,
		98919
	],
	"./solid/file-arrow-up.svg": [
		42949,
		42949
	],
	"./solid/file-audio.svg": [
		76316,
		76316
	],
	"./solid/file-circle-check.svg": [
		67180,
		67180
	],
	"./solid/file-circle-exclamation.svg": [
		83248,
		83248
	],
	"./solid/file-circle-minus.svg": [
		98915,
		25026
	],
	"./solid/file-circle-plus.svg": [
		62206,
		62206
	],
	"./solid/file-circle-question.svg": [
		9328,
		9328
	],
	"./solid/file-circle-xmark.svg": [
		38540,
		38540
	],
	"./solid/file-code.svg": [
		6583,
		6583
	],
	"./solid/file-contract.svg": [
		20566,
		20566
	],
	"./solid/file-csv.svg": [
		84938,
		84938
	],
	"./solid/file-excel.svg": [
		86763,
		86763
	],
	"./solid/file-export.svg": [
		77484,
		77484
	],
	"./solid/file-image.svg": [
		8205,
		8205
	],
	"./solid/file-import.svg": [
		21391,
		21391
	],
	"./solid/file-invoice-dollar.svg": [
		50240,
		50240
	],
	"./solid/file-invoice.svg": [
		73508,
		73508
	],
	"./solid/file-lines.svg": [
		29910,
		29910
	],
	"./solid/file-medical.svg": [
		13208,
		13208
	],
	"./solid/file-pdf.svg": [
		66865,
		66865
	],
	"./solid/file-pen.svg": [
		35553,
		35553
	],
	"./solid/file-powerpoint.svg": [
		88905,
		88905
	],
	"./solid/file-prescription.svg": [
		4429,
		4429
	],
	"./solid/file-shield.svg": [
		56242,
		56242
	],
	"./solid/file-signature.svg": [
		896,
		896
	],
	"./solid/file-video.svg": [
		86907,
		86907
	],
	"./solid/file-waveform.svg": [
		67414,
		67414
	],
	"./solid/file-word.svg": [
		19033,
		19033
	],
	"./solid/file-zipper.svg": [
		63400,
		63400
	],
	"./solid/file.svg": [
		17240,
		17240
	],
	"./solid/fill-drip.svg": [
		37788,
		37788
	],
	"./solid/fill.svg": [
		9163,
		9163
	],
	"./solid/film.svg": [
		26213,
		26213
	],
	"./solid/filter-circle-dollar.svg": [
		8043,
		8043
	],
	"./solid/filter-circle-xmark.svg": [
		66202,
		66202
	],
	"./solid/filter.svg": [
		9142,
		9142
	],
	"./solid/fingerprint.svg": [
		95915,
		95915
	],
	"./solid/fire-burner.svg": [
		31281,
		31281
	],
	"./solid/fire-extinguisher.svg": [
		63002,
		63002
	],
	"./solid/fire-flame-curved.svg": [
		2484,
		2484
	],
	"./solid/fire-flame-simple.svg": [
		81298,
		81298
	],
	"./solid/fire.svg": [
		20701,
		20701
	],
	"./solid/fish-fins.svg": [
		16477,
		16477
	],
	"./solid/fish.svg": [
		7515,
		7515
	],
	"./solid/flag-checkered.svg": [
		44281,
		44281
	],
	"./solid/flag-usa.svg": [
		72371,
		72371
	],
	"./solid/flag.svg": [
		59738,
		59738
	],
	"./solid/flask-vial.svg": [
		56505,
		56505
	],
	"./solid/flask.svg": [
		327,
		327
	],
	"./solid/floppy-disk.svg": [
		71476,
		71476
	],
	"./solid/florin-sign.svg": [
		79077,
		79077
	],
	"./solid/folder-closed.svg": [
		23169,
		98915
	],
	"./solid/folder-minus.svg": [
		57620,
		57620
	],
	"./solid/folder-open.svg": [
		71304,
		71304
	],
	"./solid/folder-plus.svg": [
		84393,
		84393
	],
	"./solid/folder-tree.svg": [
		91277,
		91277
	],
	"./solid/folder.svg": [
		60904,
		60904
	],
	"./solid/font-awesome.svg": [
		31213,
		31213
	],
	"./solid/font.svg": [
		30134,
		30134
	],
	"./solid/football.svg": [
		3217,
		3217
	],
	"./solid/forward-fast.svg": [
		25677,
		25677
	],
	"./solid/forward-step.svg": [
		81640,
		81640
	],
	"./solid/forward.svg": [
		59362,
		59362
	],
	"./solid/franc-sign.svg": [
		23605,
		23605
	],
	"./solid/frog.svg": [
		96018,
		96018
	],
	"./solid/futbol.svg": [
		96336,
		96336
	],
	"./solid/g.svg": [
		78895,
		78895
	],
	"./solid/gamepad.svg": [
		18487,
		18487
	],
	"./solid/gas-pump.svg": [
		8370,
		8370
	],
	"./solid/gauge-high.svg": [
		75593,
		75593
	],
	"./solid/gauge-simple-high.svg": [
		24441,
		24441
	],
	"./solid/gauge-simple.svg": [
		83101,
		83101
	],
	"./solid/gauge.svg": [
		34049,
		34049
	],
	"./solid/gavel.svg": [
		22617,
		22617
	],
	"./solid/gear.svg": [
		49373,
		49373
	],
	"./solid/gears.svg": [
		30514,
		30514
	],
	"./solid/gem.svg": [
		61071,
		61071
	],
	"./solid/genderless.svg": [
		87372,
		87372
	],
	"./solid/ghost.svg": [
		90735,
		90735
	],
	"./solid/gift.svg": [
		80357,
		80357
	],
	"./solid/gifts.svg": [
		5024,
		5024
	],
	"./solid/glass-water-droplet.svg": [
		18624,
		18624
	],
	"./solid/glass-water.svg": [
		95272,
		95272
	],
	"./solid/glasses.svg": [
		4430,
		4430
	],
	"./solid/globe.svg": [
		21020,
		21020
	],
	"./solid/golf-ball-tee.svg": [
		74124,
		74124
	],
	"./solid/gopuram.svg": [
		66063,
		66063
	],
	"./solid/graduation-cap.svg": [
		83859,
		83859
	],
	"./solid/greater-than-equal.svg": [
		92884,
		92884
	],
	"./solid/greater-than.svg": [
		54589,
		54589
	],
	"./solid/grip-lines-vertical.svg": [
		72354,
		72354
	],
	"./solid/grip-lines.svg": [
		83794,
		83794
	],
	"./solid/grip-vertical.svg": [
		17687,
		17687
	],
	"./solid/grip.svg": [
		31982,
		31982
	],
	"./solid/group-arrows-rotate.svg": [
		59106,
		59106
	],
	"./solid/guarani-sign.svg": [
		1279,
		1279
	],
	"./solid/guitar.svg": [
		21823,
		21823
	],
	"./solid/gun.svg": [
		8837,
		8837
	],
	"./solid/h.svg": [
		58439,
		58439
	],
	"./solid/hammer.svg": [
		92589,
		92589
	],
	"./solid/hamsa.svg": [
		41169,
		41169
	],
	"./solid/hand-back-fist.svg": [
		54473,
		54473
	],
	"./solid/hand-dots.svg": [
		81854,
		81854
	],
	"./solid/hand-fist.svg": [
		45109,
		45109
	],
	"./solid/hand-holding-dollar.svg": [
		19540,
		19540
	],
	"./solid/hand-holding-droplet.svg": [
		20754,
		20754
	],
	"./solid/hand-holding-hand.svg": [
		41592,
		41592
	],
	"./solid/hand-holding-heart.svg": [
		30863,
		30863
	],
	"./solid/hand-holding-medical.svg": [
		9975,
		9975
	],
	"./solid/hand-holding.svg": [
		69283,
		69283
	],
	"./solid/hand-lizard.svg": [
		67289,
		67289
	],
	"./solid/hand-middle-finger.svg": [
		71377,
		71377
	],
	"./solid/hand-peace.svg": [
		22387,
		22387
	],
	"./solid/hand-point-down.svg": [
		66361,
		66361
	],
	"./solid/hand-point-left.svg": [
		35649,
		35649
	],
	"./solid/hand-point-right.svg": [
		65233,
		65233
	],
	"./solid/hand-point-up.svg": [
		28333,
		28333
	],
	"./solid/hand-pointer.svg": [
		47825,
		47825
	],
	"./solid/hand-scissors.svg": [
		71921,
		71921
	],
	"./solid/hand-sparkles.svg": [
		7268,
		7268
	],
	"./solid/hand-spock.svg": [
		52937,
		52937
	],
	"./solid/hand.svg": [
		43054,
		43054
	],
	"./solid/handcuffs.svg": [
		98824,
		98824
	],
	"./solid/hands-asl-interpreting.svg": [
		62630,
		62630
	],
	"./solid/hands-bound.svg": [
		81429,
		81429
	],
	"./solid/hands-bubbles.svg": [
		54672,
		54672
	],
	"./solid/hands-clapping.svg": [
		29354,
		29354
	],
	"./solid/hands-holding-child.svg": [
		21536,
		21536
	],
	"./solid/hands-holding-circle.svg": [
		21850,
		21850
	],
	"./solid/hands-holding.svg": [
		87063,
		87063
	],
	"./solid/hands-praying.svg": [
		1180,
		1180
	],
	"./solid/hands.svg": [
		41103,
		41103
	],
	"./solid/handshake-angle.svg": [
		29144,
		29144
	],
	"./solid/handshake-simple-slash.svg": [
		76274,
		76274
	],
	"./solid/handshake-simple.svg": [
		1884,
		1884
	],
	"./solid/handshake-slash.svg": [
		21930,
		21930
	],
	"./solid/handshake.svg": [
		87022,
		87022
	],
	"./solid/hanukiah.svg": [
		64268,
		64268
	],
	"./solid/hard-drive.svg": [
		75902,
		75902
	],
	"./solid/hashtag.svg": [
		99296,
		99296
	],
	"./solid/hat-cowboy-side.svg": [
		27258,
		27258
	],
	"./solid/hat-cowboy.svg": [
		15368,
		15368
	],
	"./solid/hat-wizard.svg": [
		54869,
		54869
	],
	"./solid/head-side-cough-slash.svg": [
		11517,
		11517
	],
	"./solid/head-side-cough.svg": [
		91084,
		3905
	],
	"./solid/head-side-mask.svg": [
		96501,
		96501
	],
	"./solid/head-side-virus.svg": [
		62972,
		62972
	],
	"./solid/heading.svg": [
		95487,
		14293
	],
	"./solid/headphones-simple.svg": [
		14034,
		14034
	],
	"./solid/headphones.svg": [
		82092,
		82092
	],
	"./solid/headset.svg": [
		64732,
		64732
	],
	"./solid/heart-circle-bolt.svg": [
		75385,
		75385
	],
	"./solid/heart-circle-check.svg": [
		72141,
		72141
	],
	"./solid/heart-circle-exclamation.svg": [
		46011,
		46011
	],
	"./solid/heart-circle-minus.svg": [
		83132,
		83132
	],
	"./solid/heart-circle-plus.svg": [
		12701,
		12701
	],
	"./solid/heart-circle-xmark.svg": [
		17719,
		17719
	],
	"./solid/heart-crack.svg": [
		39331,
		39331
	],
	"./solid/heart-pulse.svg": [
		1439,
		1439
	],
	"./solid/heart.svg": [
		36089,
		36089
	],
	"./solid/helicopter-symbol.svg": [
		20388,
		20388
	],
	"./solid/helicopter.svg": [
		66904,
		66904
	],
	"./solid/helmet-safety.svg": [
		2521,
		2521
	],
	"./solid/helmet-un.svg": [
		10120,
		10120
	],
	"./solid/highlighter.svg": [
		95764,
		61494
	],
	"./solid/hill-avalanche.svg": [
		5099,
		5099
	],
	"./solid/hill-rockslide.svg": [
		29472,
		29472
	],
	"./solid/hippo.svg": [
		41020,
		41020
	],
	"./solid/hockey-puck.svg": [
		75339,
		75339
	],
	"./solid/holly-berry.svg": [
		40596,
		40596
	],
	"./solid/horse-head.svg": [
		49205,
		49205
	],
	"./solid/horse.svg": [
		45618,
		45618
	],
	"./solid/hospital-user.svg": [
		72430,
		72430
	],
	"./solid/hospital.svg": [
		63542,
		63542
	],
	"./solid/hot-tub-person.svg": [
		49665,
		49665
	],
	"./solid/hotdog.svg": [
		70666,
		70666
	],
	"./solid/hotel.svg": [
		18134,
		18134
	],
	"./solid/hourglass-end.svg": [
		21961,
		21961
	],
	"./solid/hourglass-half.svg": [
		30303,
		30303
	],
	"./solid/hourglass-start.svg": [
		96149,
		96149
	],
	"./solid/hourglass.svg": [
		61014,
		61014
	],
	"./solid/house-chimney-crack.svg": [
		29155,
		29155
	],
	"./solid/house-chimney-medical.svg": [
		64122,
		64122
	],
	"./solid/house-chimney-user.svg": [
		64665,
		64665
	],
	"./solid/house-chimney-window.svg": [
		18769,
		18769
	],
	"./solid/house-chimney.svg": [
		60295,
		60295
	],
	"./solid/house-circle-check.svg": [
		59907,
		59907
	],
	"./solid/house-circle-exclamation.svg": [
		3907,
		3907
	],
	"./solid/house-circle-xmark.svg": [
		62366,
		62366
	],
	"./solid/house-crack.svg": [
		56839,
		56839
	],
	"./solid/house-fire.svg": [
		81069,
		81069
	],
	"./solid/house-flag.svg": [
		37457,
		37457
	],
	"./solid/house-flood-water-circle-arrow-right.svg": [
		38086,
		38086
	],
	"./solid/house-flood-water.svg": [
		7759,
		7759
	],
	"./solid/house-laptop.svg": [
		91770,
		91770
	],
	"./solid/house-lock.svg": [
		71707,
		71707
	],
	"./solid/house-medical-circle-check.svg": [
		2876,
		2876
	],
	"./solid/house-medical-circle-exclamation.svg": [
		56927,
		56927
	],
	"./solid/house-medical-circle-xmark.svg": [
		76213,
		76213
	],
	"./solid/house-medical-flag.svg": [
		30070,
		30070
	],
	"./solid/house-medical.svg": [
		53357,
		53357
	],
	"./solid/house-signal.svg": [
		77829,
		77829
	],
	"./solid/house-tsunami.svg": [
		8181,
		8181
	],
	"./solid/house-user.svg": [
		56578,
		56578
	],
	"./solid/house.svg": [
		50112,
		50112
	],
	"./solid/hryvnia-sign.svg": [
		18325,
		18325
	],
	"./solid/hurricane.svg": [
		77360,
		77360
	],
	"./solid/i-cursor.svg": [
		46531,
		46531
	],
	"./solid/i.svg": [
		11956,
		11956
	],
	"./solid/ice-cream.svg": [
		12208,
		12208
	],
	"./solid/icicles.svg": [
		60966,
		60966
	],
	"./solid/icons.svg": [
		96897,
		96897
	],
	"./solid/id-badge.svg": [
		19782,
		19782
	],
	"./solid/id-card-clip.svg": [
		12258,
		12258
	],
	"./solid/id-card.svg": [
		87398,
		87398
	],
	"./solid/igloo.svg": [
		79177,
		79177
	],
	"./solid/image-portrait.svg": [
		52870,
		52870
	],
	"./solid/image.svg": [
		35844,
		35844
	],
	"./solid/images.svg": [
		37498,
		37498
	],
	"./solid/inbox.svg": [
		78862,
		78862
	],
	"./solid/indent.svg": [
		59291,
		59291
	],
	"./solid/indian-rupee-sign.svg": [
		18165,
		18165
	],
	"./solid/industry.svg": [
		4647,
		4647
	],
	"./solid/infinity.svg": [
		54033,
		54033
	],
	"./solid/info.svg": [
		68157,
		68157
	],
	"./solid/italic.svg": [
		84528,
		84528
	],
	"./solid/j.svg": [
		1696,
		1696
	],
	"./solid/jar-wheat.svg": [
		36918,
		36918
	],
	"./solid/jar.svg": [
		62329,
		59881
	],
	"./solid/jedi.svg": [
		86175,
		86175
	],
	"./solid/jet-fighter-up.svg": [
		17962,
		17962
	],
	"./solid/jet-fighter.svg": [
		80216,
		80216
	],
	"./solid/joint.svg": [
		10197,
		50085
	],
	"./solid/jug-detergent.svg": [
		42588,
		42588
	],
	"./solid/k.svg": [
		4784,
		4784
	],
	"./solid/kaaba.svg": [
		99089,
		99089
	],
	"./solid/key.svg": [
		68307,
		68307
	],
	"./solid/keyboard.svg": [
		53594,
		53594
	],
	"./solid/khanda.svg": [
		76711,
		76711
	],
	"./solid/kip-sign.svg": [
		35257,
		35257
	],
	"./solid/kit-medical.svg": [
		66656,
		66656
	],
	"./solid/kitchen-set.svg": [
		15861,
		15861
	],
	"./solid/kiwi-bird.svg": [
		17165,
		17165
	],
	"./solid/l.svg": [
		22668,
		22668
	],
	"./solid/land-mine-on.svg": [
		36689,
		36689
	],
	"./solid/landmark-dome.svg": [
		39437,
		39437
	],
	"./solid/landmark-flag.svg": [
		17605,
		17605
	],
	"./solid/landmark.svg": [
		362,
		362
	],
	"./solid/language.svg": [
		33371,
		33371
	],
	"./solid/laptop-code.svg": [
		89247,
		89247
	],
	"./solid/laptop-file.svg": [
		76305,
		76305
	],
	"./solid/laptop-medical.svg": [
		41491,
		41491
	],
	"./solid/laptop.svg": [
		67286,
		67286
	],
	"./solid/lari-sign.svg": [
		27292,
		27292
	],
	"./solid/layer-group.svg": [
		93910,
		93910
	],
	"./solid/leaf.svg": [
		58705,
		58705
	],
	"./solid/left-long.svg": [
		79240,
		79240
	],
	"./solid/left-right.svg": [
		36287,
		36287
	],
	"./solid/lemon.svg": [
		67060,
		67060
	],
	"./solid/less-than-equal.svg": [
		87292,
		87292
	],
	"./solid/less-than.svg": [
		46891,
		77157
	],
	"./solid/life-ring.svg": [
		19683,
		19683
	],
	"./solid/lightbulb.svg": [
		94498,
		94498
	],
	"./solid/lines-leaning.svg": [
		48474,
		48474
	],
	"./solid/link-slash.svg": [
		87993,
		87993
	],
	"./solid/link.svg": [
		43203,
		43203
	],
	"./solid/lira-sign.svg": [
		43279,
		43279
	],
	"./solid/list-check.svg": [
		64471,
		64471
	],
	"./solid/list-ol.svg": [
		928,
		928
	],
	"./solid/list-ul.svg": [
		9099,
		9099
	],
	"./solid/list.svg": [
		16584,
		16584
	],
	"./solid/litecoin-sign.svg": [
		76901,
		76901
	],
	"./solid/location-arrow.svg": [
		35888,
		35888
	],
	"./solid/location-crosshairs.svg": [
		93007,
		9419
	],
	"./solid/location-dot.svg": [
		38360,
		38360
	],
	"./solid/location-pin-lock.svg": [
		71641,
		71641
	],
	"./solid/location-pin.svg": [
		99379,
		99379
	],
	"./solid/lock-open.svg": [
		73478,
		73478
	],
	"./solid/lock.svg": [
		27391,
		86163
	],
	"./solid/locust.svg": [
		8560,
		8560
	],
	"./solid/lungs-virus.svg": [
		96262,
		96262
	],
	"./solid/lungs.svg": [
		99994,
		99994
	],
	"./solid/m.svg": [
		14485,
		14485
	],
	"./solid/magnet.svg": [
		52763,
		52763
	],
	"./solid/magnifying-glass-arrow-right.svg": [
		67149,
		67149
	],
	"./solid/magnifying-glass-chart.svg": [
		35149,
		35149
	],
	"./solid/magnifying-glass-dollar.svg": [
		28515,
		28515
	],
	"./solid/magnifying-glass-location.svg": [
		64795,
		64795
	],
	"./solid/magnifying-glass-minus.svg": [
		2241,
		2241
	],
	"./solid/magnifying-glass-plus.svg": [
		98635,
		98635
	],
	"./solid/magnifying-glass.svg": [
		66357,
		66357
	],
	"./solid/manat-sign.svg": [
		62898,
		62898
	],
	"./solid/map-location-dot.svg": [
		91537,
		91537
	],
	"./solid/map-location.svg": [
		59165,
		59165
	],
	"./solid/map-pin.svg": [
		49846,
		49846
	],
	"./solid/map.svg": [
		79156,
		99853
	],
	"./solid/marker.svg": [
		41110,
		41110
	],
	"./solid/mars-and-venus-burst.svg": [
		14200,
		14200
	],
	"./solid/mars-and-venus.svg": [
		41482,
		41482
	],
	"./solid/mars-double.svg": [
		10287,
		10287
	],
	"./solid/mars-stroke-right.svg": [
		91322,
		91322
	],
	"./solid/mars-stroke-up.svg": [
		75644,
		75644
	],
	"./solid/mars-stroke.svg": [
		66433,
		66433
	],
	"./solid/mars.svg": [
		63156,
		63156
	],
	"./solid/martini-glass-citrus.svg": [
		11199,
		11199
	],
	"./solid/martini-glass-empty.svg": [
		18900,
		18900
	],
	"./solid/martini-glass.svg": [
		26451,
		26451
	],
	"./solid/mask-face.svg": [
		61641,
		61641
	],
	"./solid/mask-ventilator.svg": [
		90060,
		90060
	],
	"./solid/mask.svg": [
		81514,
		81514
	],
	"./solid/masks-theater.svg": [
		82496,
		82496
	],
	"./solid/mattress-pillow.svg": [
		91339,
		91339
	],
	"./solid/maximize.svg": [
		77166,
		44586
	],
	"./solid/medal.svg": [
		28693,
		28693
	],
	"./solid/memory.svg": [
		67170,
		67170
	],
	"./solid/menorah.svg": [
		84407,
		84407
	],
	"./solid/mercury.svg": [
		20170,
		88947
	],
	"./solid/message.svg": [
		34139,
		34139
	],
	"./solid/meteor.svg": [
		45256,
		45256
	],
	"./solid/microchip.svg": [
		13993,
		13993
	],
	"./solid/microphone-lines-slash.svg": [
		97081,
		97081
	],
	"./solid/microphone-lines.svg": [
		45111,
		45111
	],
	"./solid/microphone-slash.svg": [
		63005,
		63005
	],
	"./solid/microphone.svg": [
		96036,
		96036
	],
	"./solid/microscope.svg": [
		3071,
		91084
	],
	"./solid/mill-sign.svg": [
		78323,
		78323
	],
	"./solid/minimize.svg": [
		1762,
		1762
	],
	"./solid/minus.svg": [
		46756,
		46756
	],
	"./solid/mitten.svg": [
		36803,
		36803
	],
	"./solid/mobile-button.svg": [
		37321,
		37321
	],
	"./solid/mobile-retro.svg": [
		95776,
		37898
	],
	"./solid/mobile-screen-button.svg": [
		24210,
		24210
	],
	"./solid/mobile-screen.svg": [
		73810,
		38200
	],
	"./solid/mobile.svg": [
		94816,
		94816
	],
	"./solid/money-bill-1-wave.svg": [
		23043,
		23043
	],
	"./solid/money-bill-1.svg": [
		61523,
		61523
	],
	"./solid/money-bill-transfer.svg": [
		3868,
		3868
	],
	"./solid/money-bill-trend-up.svg": [
		83218,
		83218
	],
	"./solid/money-bill-wave.svg": [
		61140,
		61140
	],
	"./solid/money-bill-wheat.svg": [
		37130,
		37130
	],
	"./solid/money-bill.svg": [
		50125,
		50125
	],
	"./solid/money-bills.svg": [
		25593,
		25593
	],
	"./solid/money-check-dollar.svg": [
		12671,
		12671
	],
	"./solid/money-check.svg": [
		78484,
		78484
	],
	"./solid/monument.svg": [
		42051,
		42051
	],
	"./solid/moon.svg": [
		56487,
		56487
	],
	"./solid/mortar-pestle.svg": [
		89826,
		89826
	],
	"./solid/mosque.svg": [
		93562,
		93562
	],
	"./solid/mosquito-net.svg": [
		54929,
		54929
	],
	"./solid/mosquito.svg": [
		30048,
		30048
	],
	"./solid/motorcycle.svg": [
		41504,
		41504
	],
	"./solid/mound.svg": [
		54516,
		54516
	],
	"./solid/mountain-city.svg": [
		13641,
		13641
	],
	"./solid/mountain-sun.svg": [
		84493,
		84493
	],
	"./solid/mountain.svg": [
		85504,
		85504
	],
	"./solid/mug-hot.svg": [
		83302,
		83302
	],
	"./solid/mug-saucer.svg": [
		63023,
		63023
	],
	"./solid/music.svg": [
		70742,
		70742
	],
	"./solid/n.svg": [
		80120,
		80120
	],
	"./solid/naira-sign.svg": [
		89402,
		89402
	],
	"./solid/network-wired.svg": [
		59778,
		59778
	],
	"./solid/neuter.svg": [
		41287,
		41287
	],
	"./solid/newspaper.svg": [
		39952,
		39952
	],
	"./solid/not-equal.svg": [
		10035,
		10035
	],
	"./solid/notdef.svg": [
		86937,
		86937
	],
	"./solid/note-sticky.svg": [
		50833,
		50833
	],
	"./solid/notes-medical.svg": [
		54226,
		7316
	],
	"./solid/o.svg": [
		16214,
		16214
	],
	"./solid/object-group.svg": [
		70673,
		70673
	],
	"./solid/object-ungroup.svg": [
		36372,
		36372
	],
	"./solid/oil-can.svg": [
		35864,
		35864
	],
	"./solid/oil-well.svg": [
		41990,
		41990
	],
	"./solid/om.svg": [
		68185,
		68185
	],
	"./solid/otter.svg": [
		91646,
		91646
	],
	"./solid/outdent.svg": [
		61053,
		61053
	],
	"./solid/p.svg": [
		46177,
		46177
	],
	"./solid/pager.svg": [
		5008,
		5008
	],
	"./solid/paint-roller.svg": [
		69792,
		69792
	],
	"./solid/paintbrush.svg": [
		63972,
		63972
	],
	"./solid/palette.svg": [
		74732,
		74732
	],
	"./solid/pallet.svg": [
		99825,
		99825
	],
	"./solid/panorama.svg": [
		61543,
		61543
	],
	"./solid/paper-plane.svg": [
		50483,
		50483
	],
	"./solid/paperclip.svg": [
		88875,
		88875
	],
	"./solid/parachute-box.svg": [
		26083,
		26083
	],
	"./solid/paragraph.svg": [
		92115,
		92115
	],
	"./solid/passport.svg": [
		70874,
		70874
	],
	"./solid/paste.svg": [
		13648,
		13648
	],
	"./solid/pause.svg": [
		85825,
		85825
	],
	"./solid/paw.svg": [
		46895,
		46895
	],
	"./solid/peace.svg": [
		74273,
		74273
	],
	"./solid/pen-clip.svg": [
		39386,
		39386
	],
	"./solid/pen-fancy.svg": [
		4970,
		4970
	],
	"./solid/pen-nib.svg": [
		48166,
		48166
	],
	"./solid/pen-ruler.svg": [
		70579,
		70579
	],
	"./solid/pen-to-square.svg": [
		49887,
		49887
	],
	"./solid/pen.svg": [
		98946,
		98946
	],
	"./solid/pencil.svg": [
		10687,
		10687
	],
	"./solid/people-arrows.svg": [
		54759,
		54759
	],
	"./solid/people-carry-box.svg": [
		12166,
		12166
	],
	"./solid/people-group.svg": [
		72967,
		95776
	],
	"./solid/people-line.svg": [
		97166,
		97166
	],
	"./solid/people-pulling.svg": [
		93167,
		93167
	],
	"./solid/people-robbery.svg": [
		42426,
		42426
	],
	"./solid/people-roof.svg": [
		19238,
		19238
	],
	"./solid/pepper-hot.svg": [
		78985,
		78985
	],
	"./solid/percent.svg": [
		59221,
		59221
	],
	"./solid/person-arrow-down-to-line.svg": [
		61871,
		61871
	],
	"./solid/person-arrow-up-from-line.svg": [
		16964,
		16964
	],
	"./solid/person-biking.svg": [
		91423,
		91423
	],
	"./solid/person-booth.svg": [
		39257,
		39257
	],
	"./solid/person-breastfeeding.svg": [
		4624,
		4624
	],
	"./solid/person-burst.svg": [
		42066,
		42066
	],
	"./solid/person-cane.svg": [
		76993,
		76993
	],
	"./solid/person-chalkboard.svg": [
		21599,
		21599
	],
	"./solid/person-circle-check.svg": [
		95122,
		95122
	],
	"./solid/person-circle-exclamation.svg": [
		35625,
		35625
	],
	"./solid/person-circle-minus.svg": [
		73641,
		73641
	],
	"./solid/person-circle-plus.svg": [
		63741,
		63741
	],
	"./solid/person-circle-question.svg": [
		61986,
		61986
	],
	"./solid/person-circle-xmark.svg": [
		48481,
		48481
	],
	"./solid/person-digging.svg": [
		27243,
		35483
	],
	"./solid/person-dots-from-line.svg": [
		50229,
		50229
	],
	"./solid/person-dress-burst.svg": [
		28767,
		28767
	],
	"./solid/person-dress.svg": [
		77934,
		77934
	],
	"./solid/person-drowning.svg": [
		91073,
		91073
	],
	"./solid/person-falling-burst.svg": [
		92828,
		92828
	],
	"./solid/person-falling.svg": [
		52761,
		52761
	],
	"./solid/person-half-dress.svg": [
		62562,
		62562
	],
	"./solid/person-harassing.svg": [
		66651,
		66651
	],
	"./solid/person-hiking.svg": [
		79721,
		79721
	],
	"./solid/person-military-pointing.svg": [
		4083,
		4083
	],
	"./solid/person-military-rifle.svg": [
		31494,
		31494
	],
	"./solid/person-military-to-person.svg": [
		78072,
		51340
	],
	"./solid/person-praying.svg": [
		54546,
		54546
	],
	"./solid/person-pregnant.svg": [
		45871,
		45871
	],
	"./solid/person-rays.svg": [
		40653,
		40653
	],
	"./solid/person-rifle.svg": [
		61631,
		61631
	],
	"./solid/person-running.svg": [
		7061,
		7061
	],
	"./solid/person-shelter.svg": [
		98519,
		98519
	],
	"./solid/person-skating.svg": [
		31774,
		31774
	],
	"./solid/person-skiing-nordic.svg": [
		4169,
		4169
	],
	"./solid/person-skiing.svg": [
		3862,
		3862
	],
	"./solid/person-snowboarding.svg": [
		8208,
		8208
	],
	"./solid/person-swimming.svg": [
		88472,
		88472
	],
	"./solid/person-through-window.svg": [
		17303,
		17303
	],
	"./solid/person-walking-arrow-loop-left.svg": [
		66915,
		66915
	],
	"./solid/person-walking-arrow-right.svg": [
		89902,
		89902
	],
	"./solid/person-walking-dashed-line-arrow-right.svg": [
		24008,
		24008
	],
	"./solid/person-walking-luggage.svg": [
		22044,
		22044
	],
	"./solid/person-walking-with-cane.svg": [
		891,
		891
	],
	"./solid/person-walking.svg": [
		20017,
		20017
	],
	"./solid/person.svg": [
		230,
		230
	],
	"./solid/peseta-sign.svg": [
		24518,
		24518
	],
	"./solid/peso-sign.svg": [
		51414,
		51414
	],
	"./solid/phone-flip.svg": [
		53208,
		53208
	],
	"./solid/phone-slash.svg": [
		82647,
		82647
	],
	"./solid/phone-volume.svg": [
		78655,
		1469
	],
	"./solid/phone.svg": [
		49014,
		49014
	],
	"./solid/photo-film.svg": [
		34443,
		34443
	],
	"./solid/piggy-bank.svg": [
		17564,
		17564
	],
	"./solid/pills.svg": [
		9222,
		94297
	],
	"./solid/pizza-slice.svg": [
		9858,
		9858
	],
	"./solid/place-of-worship.svg": [
		78925,
		78925
	],
	"./solid/plane-arrival.svg": [
		89250,
		89250
	],
	"./solid/plane-circle-check.svg": [
		9383,
		9383
	],
	"./solid/plane-circle-exclamation.svg": [
		73214,
		73214
	],
	"./solid/plane-circle-xmark.svg": [
		20583,
		20583
	],
	"./solid/plane-departure.svg": [
		25722,
		25722
	],
	"./solid/plane-lock.svg": [
		11208,
		11208
	],
	"./solid/plane-slash.svg": [
		94453,
		94453
	],
	"./solid/plane-up.svg": [
		1198,
		1198
	],
	"./solid/plane.svg": [
		30612,
		30612
	],
	"./solid/plant-wilt.svg": [
		55091,
		55091
	],
	"./solid/plate-wheat.svg": [
		20018,
		20018
	],
	"./solid/play.svg": [
		89834,
		89834
	],
	"./solid/plug-circle-bolt.svg": [
		15290,
		15290
	],
	"./solid/plug-circle-check.svg": [
		58963,
		58963
	],
	"./solid/plug-circle-exclamation.svg": [
		46483,
		46483
	],
	"./solid/plug-circle-minus.svg": [
		28697,
		28697
	],
	"./solid/plug-circle-plus.svg": [
		38289,
		38289
	],
	"./solid/plug-circle-xmark.svg": [
		51645,
		51645
	],
	"./solid/plug.svg": [
		75264,
		75264
	],
	"./solid/plus-minus.svg": [
		99280,
		99280
	],
	"./solid/plus.svg": [
		50223,
		50223
	],
	"./solid/podcast.svg": [
		11618,
		11618
	],
	"./solid/poo-storm.svg": [
		97818,
		97818
	],
	"./solid/poo.svg": [
		78275,
		78275
	],
	"./solid/poop.svg": [
		46905,
		46905
	],
	"./solid/power-off.svg": [
		87121,
		87121
	],
	"./solid/prescription-bottle-medical.svg": [
		24728,
		24728
	],
	"./solid/prescription-bottle.svg": [
		80810,
		80810
	],
	"./solid/prescription.svg": [
		17300,
		17300
	],
	"./solid/print.svg": [
		62837,
		62837
	],
	"./solid/pump-medical.svg": [
		64443,
		64443
	],
	"./solid/pump-soap.svg": [
		97482,
		97482
	],
	"./solid/puzzle-piece.svg": [
		84976,
		84976
	],
	"./solid/q.svg": [
		6413,
		6413
	],
	"./solid/qrcode.svg": [
		87455,
		87455
	],
	"./solid/question.svg": [
		72396,
		72396
	],
	"./solid/quote-left.svg": [
		22671,
		22671
	],
	"./solid/quote-right.svg": [
		6732,
		6732
	],
	"./solid/r.svg": [
		24607,
		24607
	],
	"./solid/radiation.svg": [
		45674,
		45674
	],
	"./solid/radio.svg": [
		76532,
		95797
	],
	"./solid/rainbow.svg": [
		66808,
		66808
	],
	"./solid/ranking-star.svg": [
		85590,
		85590
	],
	"./solid/receipt.svg": [
		96361,
		96361
	],
	"./solid/record-vinyl.svg": [
		60411,
		60411
	],
	"./solid/rectangle-ad.svg": [
		95734,
		95734
	],
	"./solid/rectangle-list.svg": [
		80415,
		80415
	],
	"./solid/rectangle-xmark.svg": [
		21218,
		21218
	],
	"./solid/recycle.svg": [
		85660,
		85660
	],
	"./solid/registered.svg": [
		74830,
		74830
	],
	"./solid/repeat.svg": [
		2274,
		2274
	],
	"./solid/reply-all.svg": [
		52033,
		52033
	],
	"./solid/reply.svg": [
		94827,
		94827
	],
	"./solid/republican.svg": [
		40457,
		40457
	],
	"./solid/restroom.svg": [
		15846,
		15846
	],
	"./solid/retweet.svg": [
		9571,
		9571
	],
	"./solid/ribbon.svg": [
		24047,
		65307
	],
	"./solid/right-from-bracket.svg": [
		1675,
		1675
	],
	"./solid/right-left.svg": [
		44275,
		44275
	],
	"./solid/right-long.svg": [
		82065,
		82065
	],
	"./solid/right-to-bracket.svg": [
		5588,
		5588
	],
	"./solid/ring.svg": [
		70805,
		70805
	],
	"./solid/road-barrier.svg": [
		67794,
		67794
	],
	"./solid/road-bridge.svg": [
		80483,
		80483
	],
	"./solid/road-circle-check.svg": [
		37415,
		37415
	],
	"./solid/road-circle-exclamation.svg": [
		79976,
		79976
	],
	"./solid/road-circle-xmark.svg": [
		293,
		293
	],
	"./solid/road-lock.svg": [
		151,
		151
	],
	"./solid/road-spikes.svg": [
		48934,
		48934
	],
	"./solid/road.svg": [
		10164,
		10164
	],
	"./solid/robot.svg": [
		80767,
		80767
	],
	"./solid/rocket.svg": [
		71366,
		71366
	],
	"./solid/rotate-left.svg": [
		53877,
		53877
	],
	"./solid/rotate-right.svg": [
		96705,
		96705
	],
	"./solid/rotate.svg": [
		29515,
		29515
	],
	"./solid/route.svg": [
		22864,
		22864
	],
	"./solid/rss.svg": [
		84023,
		84023
	],
	"./solid/ruble-sign.svg": [
		52754,
		52754
	],
	"./solid/rug.svg": [
		68752,
		68752
	],
	"./solid/ruler-combined.svg": [
		4174,
		4174
	],
	"./solid/ruler-horizontal.svg": [
		61108,
		61108
	],
	"./solid/ruler-vertical.svg": [
		47629,
		47629
	],
	"./solid/ruler.svg": [
		54427,
		70211
	],
	"./solid/rupee-sign.svg": [
		52298,
		52298
	],
	"./solid/rupiah-sign.svg": [
		44416,
		44416
	],
	"./solid/s.svg": [
		85154,
		85154
	],
	"./solid/sack-dollar.svg": [
		46096,
		46096
	],
	"./solid/sack-xmark.svg": [
		28457,
		28457
	],
	"./solid/sailboat.svg": [
		79313,
		79313
	],
	"./solid/satellite-dish.svg": [
		77872,
		77872
	],
	"./solid/satellite.svg": [
		6101,
		6101
	],
	"./solid/scale-balanced.svg": [
		53669,
		53669
	],
	"./solid/scale-unbalanced-flip.svg": [
		69321,
		69321
	],
	"./solid/scale-unbalanced.svg": [
		65691,
		65691
	],
	"./solid/school-circle-check.svg": [
		83572,
		83572
	],
	"./solid/school-circle-exclamation.svg": [
		86617,
		86617
	],
	"./solid/school-circle-xmark.svg": [
		28831,
		28831
	],
	"./solid/school-flag.svg": [
		62480,
		62480
	],
	"./solid/school-lock.svg": [
		50413,
		50413
	],
	"./solid/school.svg": [
		16955,
		87388
	],
	"./solid/scissors.svg": [
		1351,
		1351
	],
	"./solid/screwdriver-wrench.svg": [
		21682,
		21682
	],
	"./solid/screwdriver.svg": [
		13466,
		13466
	],
	"./solid/scroll-torah.svg": [
		68925,
		68925
	],
	"./solid/scroll.svg": [
		44816,
		82677
	],
	"./solid/sd-card.svg": [
		65856,
		65856
	],
	"./solid/section.svg": [
		72321,
		72321
	],
	"./solid/seedling.svg": [
		80149,
		80149
	],
	"./solid/server.svg": [
		83336,
		83336
	],
	"./solid/shapes.svg": [
		89628,
		89628
	],
	"./solid/share-from-square.svg": [
		47314,
		47314
	],
	"./solid/share-nodes.svg": [
		69088,
		69088
	],
	"./solid/share.svg": [
		20057,
		20057
	],
	"./solid/sheet-plastic.svg": [
		61084,
		61084
	],
	"./solid/shekel-sign.svg": [
		8041,
		8041
	],
	"./solid/shield-cat.svg": [
		70762,
		70762
	],
	"./solid/shield-dog.svg": [
		85057,
		85057
	],
	"./solid/shield-halved.svg": [
		52224,
		52224
	],
	"./solid/shield-heart.svg": [
		27181,
		27181
	],
	"./solid/shield-virus.svg": [
		29785,
		29785
	],
	"./solid/shield.svg": [
		19573,
		19573
	],
	"./solid/ship.svg": [
		38860,
		38860
	],
	"./solid/shirt.svg": [
		69790,
		69790
	],
	"./solid/shoe-prints.svg": [
		30231,
		30231
	],
	"./solid/shop-lock.svg": [
		94010,
		94010
	],
	"./solid/shop-slash.svg": [
		70440,
		70440
	],
	"./solid/shop.svg": [
		12736,
		12736
	],
	"./solid/shower.svg": [
		11730,
		18594
	],
	"./solid/shrimp.svg": [
		12893,
		12893
	],
	"./solid/shuffle.svg": [
		96096,
		96096
	],
	"./solid/shuttle-space.svg": [
		36704,
		36704
	],
	"./solid/sign-hanging.svg": [
		20115,
		46891
	],
	"./solid/signal.svg": [
		97076,
		97076
	],
	"./solid/signature.svg": [
		95624,
		95624
	],
	"./solid/signs-post.svg": [
		1301,
		1301
	],
	"./solid/sim-card.svg": [
		17245,
		17245
	],
	"./solid/sink.svg": [
		45010,
		45010
	],
	"./solid/sitemap.svg": [
		17971,
		17971
	],
	"./solid/skull-crossbones.svg": [
		7593,
		7593
	],
	"./solid/skull.svg": [
		46750,
		46750
	],
	"./solid/slash.svg": [
		88350,
		88350
	],
	"./solid/sleigh.svg": [
		89622,
		89622
	],
	"./solid/sliders.svg": [
		32539,
		32539
	],
	"./solid/smog.svg": [
		51802,
		80321
	],
	"./solid/smoking.svg": [
		83767,
		83767
	],
	"./solid/snowflake.svg": [
		34315,
		34315
	],
	"./solid/snowman.svg": [
		25943,
		25943
	],
	"./solid/snowplow.svg": [
		66921,
		66921
	],
	"./solid/soap.svg": [
		84102,
		84102
	],
	"./solid/socks.svg": [
		57961,
		57961
	],
	"./solid/solar-panel.svg": [
		92675,
		92675
	],
	"./solid/sort-down.svg": [
		77796,
		77796
	],
	"./solid/sort-up.svg": [
		44527,
		44527
	],
	"./solid/sort.svg": [
		7225,
		7225
	],
	"./solid/spa.svg": [
		71351,
		71351
	],
	"./solid/spaghetti-monster-flying.svg": [
		30571,
		30571
	],
	"./solid/spell-check.svg": [
		12013,
		12013
	],
	"./solid/spider.svg": [
		47796,
		47796
	],
	"./solid/spinner.svg": [
		35833,
		35833
	],
	"./solid/splotch.svg": [
		45683,
		45683
	],
	"./solid/spoon.svg": [
		85578,
		85578
	],
	"./solid/spray-can-sparkles.svg": [
		49085,
		49085
	],
	"./solid/spray-can.svg": [
		61708,
		61708
	],
	"./solid/square-arrow-up-right.svg": [
		58163,
		58163
	],
	"./solid/square-caret-down.svg": [
		81476,
		81476
	],
	"./solid/square-caret-left.svg": [
		55196,
		55196
	],
	"./solid/square-caret-right.svg": [
		65159,
		65159
	],
	"./solid/square-caret-up.svg": [
		43089,
		43089
	],
	"./solid/square-check.svg": [
		66762,
		36157
	],
	"./solid/square-envelope.svg": [
		94855,
		94855
	],
	"./solid/square-full.svg": [
		83060,
		83060
	],
	"./solid/square-h.svg": [
		46592,
		46592
	],
	"./solid/square-minus.svg": [
		63646,
		63646
	],
	"./solid/square-nfi.svg": [
		37300,
		37300
	],
	"./solid/square-parking.svg": [
		36645,
		36645
	],
	"./solid/square-pen.svg": [
		60020,
		60020
	],
	"./solid/square-person-confined.svg": [
		33913,
		33913
	],
	"./solid/square-phone-flip.svg": [
		63171,
		63171
	],
	"./solid/square-phone.svg": [
		23326,
		23326
	],
	"./solid/square-plus.svg": [
		53435,
		53435
	],
	"./solid/square-poll-horizontal.svg": [
		55165,
		55165
	],
	"./solid/square-poll-vertical.svg": [
		46163,
		46163
	],
	"./solid/square-root-variable.svg": [
		85992,
		85992
	],
	"./solid/square-rss.svg": [
		83627,
		83627
	],
	"./solid/square-share-nodes.svg": [
		59984,
		59984
	],
	"./solid/square-up-right.svg": [
		69863,
		69863
	],
	"./solid/square-virus.svg": [
		24424,
		24424
	],
	"./solid/square-xmark.svg": [
		58377,
		58377
	],
	"./solid/square.svg": [
		18989,
		18989
	],
	"./solid/staff-snake.svg": [
		2989,
		2989
	],
	"./solid/stairs.svg": [
		10439,
		10439
	],
	"./solid/stamp.svg": [
		88389,
		88389
	],
	"./solid/stapler.svg": [
		6440,
		6440
	],
	"./solid/star-and-crescent.svg": [
		70568,
		70568
	],
	"./solid/star-half-stroke.svg": [
		28075,
		28075
	],
	"./solid/star-half.svg": [
		23263,
		23263
	],
	"./solid/star-of-david.svg": [
		53362,
		53362
	],
	"./solid/star-of-life.svg": [
		22609,
		22609
	],
	"./solid/star.svg": [
		43620,
		43620
	],
	"./solid/sterling-sign.svg": [
		66730,
		66730
	],
	"./solid/stethoscope.svg": [
		58401,
		58401
	],
	"./solid/stop.svg": [
		32998,
		32998
	],
	"./solid/stopwatch-20.svg": [
		99736,
		99736
	],
	"./solid/stopwatch.svg": [
		18867,
		18867
	],
	"./solid/store-slash.svg": [
		16737,
		16737
	],
	"./solid/store.svg": [
		16685,
		16685
	],
	"./solid/street-view.svg": [
		32200,
		32200
	],
	"./solid/strikethrough.svg": [
		62014,
		62014
	],
	"./solid/stroopwafel.svg": [
		77175,
		77175
	],
	"./solid/subscript.svg": [
		15055,
		15055
	],
	"./solid/suitcase-medical.svg": [
		96558,
		96558
	],
	"./solid/suitcase-rolling.svg": [
		22961,
		22961
	],
	"./solid/suitcase.svg": [
		28372,
		28372
	],
	"./solid/sun-plant-wilt.svg": [
		31438,
		31438
	],
	"./solid/sun.svg": [
		31788,
		31788
	],
	"./solid/superscript.svg": [
		79574,
		79574
	],
	"./solid/swatchbook.svg": [
		66784,
		66784
	],
	"./solid/synagogue.svg": [
		41408,
		41408
	],
	"./solid/syringe.svg": [
		6748,
		6748
	],
	"./solid/t.svg": [
		32315,
		32315
	],
	"./solid/table-cells-large.svg": [
		68897,
		68897
	],
	"./solid/table-cells.svg": [
		31312,
		31312
	],
	"./solid/table-columns.svg": [
		53626,
		53626
	],
	"./solid/table-list.svg": [
		49872,
		49872
	],
	"./solid/table-tennis-paddle-ball.svg": [
		21862,
		21862
	],
	"./solid/table.svg": [
		43125,
		43125
	],
	"./solid/tablet-button.svg": [
		16922,
		16922
	],
	"./solid/tablet-screen-button.svg": [
		8469,
		8469
	],
	"./solid/tablet.svg": [
		29760,
		29760
	],
	"./solid/tablets.svg": [
		89809,
		89809
	],
	"./solid/tachograph-digital.svg": [
		58659,
		58659
	],
	"./solid/tag.svg": [
		8607,
		8607
	],
	"./solid/tags.svg": [
		80317,
		80317
	],
	"./solid/tape.svg": [
		93933,
		93933
	],
	"./solid/tarp-droplet.svg": [
		49727,
		49727
	],
	"./solid/tarp.svg": [
		600,
		600
	],
	"./solid/taxi.svg": [
		85365,
		85365
	],
	"./solid/teeth-open.svg": [
		30879,
		30879
	],
	"./solid/teeth.svg": [
		5149,
		5149
	],
	"./solid/temperature-arrow-down.svg": [
		33880,
		33880
	],
	"./solid/temperature-arrow-up.svg": [
		24847,
		24847
	],
	"./solid/temperature-empty.svg": [
		27524,
		27524
	],
	"./solid/temperature-full.svg": [
		39935,
		39935
	],
	"./solid/temperature-half.svg": [
		67417,
		67417
	],
	"./solid/temperature-high.svg": [
		54820,
		54820
	],
	"./solid/temperature-low.svg": [
		56461,
		56461
	],
	"./solid/temperature-quarter.svg": [
		89851,
		89851
	],
	"./solid/temperature-three-quarters.svg": [
		37155,
		37155
	],
	"./solid/tenge-sign.svg": [
		85525,
		85525
	],
	"./solid/tent-arrow-down-to-line.svg": [
		50492,
		50492
	],
	"./solid/tent-arrow-left-right.svg": [
		72420,
		72420
	],
	"./solid/tent-arrow-turn-left.svg": [
		7403,
		7403
	],
	"./solid/tent-arrows-down.svg": [
		88789,
		88789
	],
	"./solid/tent.svg": [
		93618,
		93618
	],
	"./solid/tents.svg": [
		71713,
		71713
	],
	"./solid/terminal.svg": [
		79357,
		79357
	],
	"./solid/text-height.svg": [
		84658,
		84658
	],
	"./solid/text-slash.svg": [
		89896,
		89896
	],
	"./solid/text-width.svg": [
		51341,
		51341
	],
	"./solid/thermometer.svg": [
		255,
		255
	],
	"./solid/thumbs-down.svg": [
		48447,
		48447
	],
	"./solid/thumbs-up.svg": [
		12362,
		12362
	],
	"./solid/thumbtack.svg": [
		45693,
		45693
	],
	"./solid/ticket-simple.svg": [
		80170,
		80170
	],
	"./solid/ticket.svg": [
		27525,
		27525
	],
	"./solid/timeline.svg": [
		80689,
		80689
	],
	"./solid/toggle-off.svg": [
		98248,
		98248
	],
	"./solid/toggle-on.svg": [
		84642,
		84642
	],
	"./solid/toilet-paper-slash.svg": [
		96605,
		96605
	],
	"./solid/toilet-paper.svg": [
		89016,
		89016
	],
	"./solid/toilet-portable.svg": [
		96742,
		96742
	],
	"./solid/toilet.svg": [
		60366,
		60366
	],
	"./solid/toilets-portable.svg": [
		96939,
		96939
	],
	"./solid/toolbox.svg": [
		57869,
		57869
	],
	"./solid/tooth.svg": [
		6455,
		6455
	],
	"./solid/torii-gate.svg": [
		43036,
		43036
	],
	"./solid/tornado.svg": [
		23629,
		23629
	],
	"./solid/tower-broadcast.svg": [
		90099,
		90099
	],
	"./solid/tower-cell.svg": [
		25311,
		25311
	],
	"./solid/tower-observation.svg": [
		35862,
		35862
	],
	"./solid/tractor.svg": [
		20909,
		20909
	],
	"./solid/trademark.svg": [
		74691,
		74691
	],
	"./solid/traffic-light.svg": [
		97267,
		97267
	],
	"./solid/trailer.svg": [
		95057,
		95057
	],
	"./solid/train-subway.svg": [
		55581,
		55581
	],
	"./solid/train-tram.svg": [
		49215,
		49215
	],
	"./solid/train.svg": [
		16846,
		16846
	],
	"./solid/transgender.svg": [
		33069,
		93007
	],
	"./solid/trash-arrow-up.svg": [
		77585,
		77585
	],
	"./solid/trash-can-arrow-up.svg": [
		45466,
		45466
	],
	"./solid/trash-can.svg": [
		58320,
		58320
	],
	"./solid/trash.svg": [
		64668,
		64668
	],
	"./solid/tree-city.svg": [
		869,
		869
	],
	"./solid/tree.svg": [
		65827,
		65827
	],
	"./solid/triangle-exclamation.svg": [
		22025,
		22025
	],
	"./solid/trophy.svg": [
		58359,
		58359
	],
	"./solid/trowel-bricks.svg": [
		78731,
		78731
	],
	"./solid/trowel.svg": [
		30734,
		30734
	],
	"./solid/truck-arrow-right.svg": [
		64653,
		64653
	],
	"./solid/truck-droplet.svg": [
		71758,
		71758
	],
	"./solid/truck-fast.svg": [
		69820,
		69820
	],
	"./solid/truck-field-un.svg": [
		13386,
		13386
	],
	"./solid/truck-field.svg": [
		77145,
		77145
	],
	"./solid/truck-front.svg": [
		89041,
		89041
	],
	"./solid/truck-medical.svg": [
		27306,
		27306
	],
	"./solid/truck-monster.svg": [
		73103,
		73103
	],
	"./solid/truck-moving.svg": [
		70861,
		70861
	],
	"./solid/truck-pickup.svg": [
		59141,
		59141
	],
	"./solid/truck-plane.svg": [
		69272,
		69272
	],
	"./solid/truck-ramp-box.svg": [
		72782,
		72782
	],
	"./solid/truck.svg": [
		38420,
		38420
	],
	"./solid/tty.svg": [
		95580,
		95580
	],
	"./solid/turkish-lira-sign.svg": [
		96520,
		96520
	],
	"./solid/turn-down.svg": [
		94472,
		94472
	],
	"./solid/turn-up.svg": [
		81529,
		81529
	],
	"./solid/tv.svg": [
		94560,
		94560
	],
	"./solid/u.svg": [
		27962,
		27962
	],
	"./solid/umbrella-beach.svg": [
		77715,
		77715
	],
	"./solid/umbrella.svg": [
		2015,
		2015
	],
	"./solid/underline.svg": [
		18021,
		18021
	],
	"./solid/universal-access.svg": [
		53588,
		53588
	],
	"./solid/unlock-keyhole.svg": [
		19794,
		19794
	],
	"./solid/unlock.svg": [
		58197,
		58197
	],
	"./solid/up-down-left-right.svg": [
		24270,
		24270
	],
	"./solid/up-down.svg": [
		3284,
		3284
	],
	"./solid/up-long.svg": [
		17821,
		17821
	],
	"./solid/up-right-and-down-left-from-center.svg": [
		31441,
		31441
	],
	"./solid/up-right-from-square.svg": [
		68234,
		68234
	],
	"./solid/upload.svg": [
		66126,
		66126
	],
	"./solid/user-astronaut.svg": [
		56645,
		56645
	],
	"./solid/user-check.svg": [
		65967,
		65967
	],
	"./solid/user-clock.svg": [
		69217,
		69217
	],
	"./solid/user-doctor.svg": [
		15874,
		15874
	],
	"./solid/user-gear.svg": [
		81835,
		81835
	],
	"./solid/user-graduate.svg": [
		36453,
		36453
	],
	"./solid/user-group.svg": [
		62537,
		62537
	],
	"./solid/user-injured.svg": [
		82788,
		82788
	],
	"./solid/user-large-slash.svg": [
		58119,
		58119
	],
	"./solid/user-large.svg": [
		44397,
		44397
	],
	"./solid/user-lock.svg": [
		67329,
		50400
	],
	"./solid/user-minus.svg": [
		21007,
		21007
	],
	"./solid/user-ninja.svg": [
		1316,
		1316
	],
	"./solid/user-nurse.svg": [
		27790,
		27790
	],
	"./solid/user-pen.svg": [
		78286,
		78286
	],
	"./solid/user-plus.svg": [
		74260,
		74260
	],
	"./solid/user-secret.svg": [
		43146,
		43146
	],
	"./solid/user-shield.svg": [
		99040,
		99040
	],
	"./solid/user-slash.svg": [
		36343,
		36343
	],
	"./solid/user-tag.svg": [
		66860,
		66860
	],
	"./solid/user-tie.svg": [
		63401,
		63401
	],
	"./solid/user-xmark.svg": [
		27834,
		27834
	],
	"./solid/user.svg": [
		93882,
		93882
	],
	"./solid/users-between-lines.svg": [
		93115,
		93115
	],
	"./solid/users-gear.svg": [
		77952,
		77952
	],
	"./solid/users-line.svg": [
		27164,
		27164
	],
	"./solid/users-rays.svg": [
		86890,
		86890
	],
	"./solid/users-rectangle.svg": [
		69706,
		69706
	],
	"./solid/users-slash.svg": [
		72388,
		72388
	],
	"./solid/users-viewfinder.svg": [
		30544,
		30544
	],
	"./solid/users.svg": [
		42456,
		42456
	],
	"./solid/utensils.svg": [
		62880,
		62880
	],
	"./solid/v.svg": [
		37436,
		37436
	],
	"./solid/van-shuttle.svg": [
		5973,
		5973
	],
	"./solid/vault.svg": [
		44334,
		44334
	],
	"./solid/vector-square.svg": [
		59343,
		59343
	],
	"./solid/venus-double.svg": [
		17127,
		17127
	],
	"./solid/venus-mars.svg": [
		67046,
		67046
	],
	"./solid/venus.svg": [
		99938,
		99938
	],
	"./solid/vest-patches.svg": [
		39972,
		39972
	],
	"./solid/vest.svg": [
		51203,
		51203
	],
	"./solid/vial-circle-check.svg": [
		890,
		890
	],
	"./solid/vial-virus.svg": [
		10989,
		10989
	],
	"./solid/vial.svg": [
		74468,
		74468
	],
	"./solid/vials.svg": [
		79969,
		79969
	],
	"./solid/video-slash.svg": [
		67592,
		67592
	],
	"./solid/video.svg": [
		11548,
		11548
	],
	"./solid/vihara.svg": [
		51125,
		51125
	],
	"./solid/virus-covid-slash.svg": [
		9418,
		9418
	],
	"./solid/virus-covid.svg": [
		95753,
		95753
	],
	"./solid/virus-slash.svg": [
		80608,
		80608
	],
	"./solid/virus.svg": [
		2505,
		2505
	],
	"./solid/viruses.svg": [
		67847,
		67847
	],
	"./solid/voicemail.svg": [
		89738,
		89738
	],
	"./solid/volcano.svg": [
		55802,
		55802
	],
	"./solid/volleyball.svg": [
		84352,
		84352
	],
	"./solid/volume-high.svg": [
		32657,
		32657
	],
	"./solid/volume-low.svg": [
		4586,
		4586
	],
	"./solid/volume-off.svg": [
		53195,
		53195
	],
	"./solid/volume-xmark.svg": [
		68039,
		68039
	],
	"./solid/vr-cardboard.svg": [
		47446,
		54226
	],
	"./solid/w.svg": [
		95512,
		95512
	],
	"./solid/walkie-talkie.svg": [
		1631,
		1631
	],
	"./solid/wallet.svg": [
		70581,
		70581
	],
	"./solid/wand-magic-sparkles.svg": [
		19681,
		33136
	],
	"./solid/wand-magic.svg": [
		25993,
		25993
	],
	"./solid/wand-sparkles.svg": [
		43059,
		43059
	],
	"./solid/warehouse.svg": [
		25168,
		25168
	],
	"./solid/water-ladder.svg": [
		57879,
		57879
	],
	"./solid/water.svg": [
		97872,
		97872
	],
	"./solid/wave-square.svg": [
		84334,
		84334
	],
	"./solid/weight-hanging.svg": [
		90266,
		90266
	],
	"./solid/weight-scale.svg": [
		68091,
		68091
	],
	"./solid/wheat-awn-circle-exclamation.svg": [
		8770,
		8770
	],
	"./solid/wheat-awn.svg": [
		78882,
		78882
	],
	"./solid/wheelchair-move.svg": [
		66966,
		66966
	],
	"./solid/wheelchair.svg": [
		39913,
		39913
	],
	"./solid/whiskey-glass.svg": [
		52037,
		52037
	],
	"./solid/wifi.svg": [
		52579,
		52579
	],
	"./solid/wind.svg": [
		87320,
		87320
	],
	"./solid/window-maximize.svg": [
		89791,
		89791
	],
	"./solid/window-minimize.svg": [
		38115,
		38115
	],
	"./solid/window-restore.svg": [
		97341,
		97341
	],
	"./solid/wine-bottle.svg": [
		56513,
		56513
	],
	"./solid/wine-glass-empty.svg": [
		40203,
		40203
	],
	"./solid/wine-glass.svg": [
		28093,
		28093
	],
	"./solid/won-sign.svg": [
		24893,
		24893
	],
	"./solid/worm.svg": [
		8052,
		8052
	],
	"./solid/wrench.svg": [
		33681,
		33681
	],
	"./solid/x-ray.svg": [
		96972,
		96972
	],
	"./solid/x.svg": [
		71214,
		71214
	],
	"./solid/xmark.svg": [
		24070,
		24070
	],
	"./solid/xmarks-lines.svg": [
		77210,
		77210
	],
	"./solid/y.svg": [
		89913,
		89913
	],
	"./solid/yen-sign.svg": [
		4459,
		4459
	],
	"./solid/yin-yang.svg": [
		16425,
		16425
	],
	"./solid/z.svg": [
		32130,
		32130
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 17015;
module.exports = webpackAsyncContext;